// GENERATED by db/tools/dump_form_fixture.py -- do not edit.
//
// Every provider form exactly as GET /programs/forms/{source} serves it:
// every section, every question, every option, in the order the endpoint
// returns them.
//
//   detox: 7 sections, 30 questions, 3 with a search box
//   outpatient: 8 sections, 32 questions, 7 with a search box
//   residential: 8 sections, 39 questions, 7 with a search box
//   sober_living: 7 sections, 32 questions, 3 with a search box
//
// Regenerate against a migrated database:
//
//     cd db && make reset
//     python db/tools/dump_form_fixture.py
//
// Hand-editing this to add or remove an option would recreate the problem it
// exists to solve -- see the script's docstring.

import type { ProgramFormDefinition, TaxonomyKind } from './contract'

export const GENERATED_FORMS: Readonly<Record<string, ProgramFormDefinition>> = {
  "detox": {
    "source": "detox",
    "title": "Utah Detox Survey",
    "estimate": "15-25 minutes",
    "sections": [
      {
        "key": "identity",
        "title": "Program & Contact",
        "helper": null,
        "questions": [
          {
            "key": "program_name",
            "question": "Program Name",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "provider_type",
            "question": "Provider Type",
            "inputType": "single_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "ed75ddf5-95a1-4094-abfb-a2718fe9fe9d",
                "label": "Detox (Other levels of care offered at program)"
              },
              {
                "taxonomyId": "629c2196-88b0-4e5f-b9ed-d8ad77cf5a3f",
                "label": "Standalone Detox (No other levels of care offered)"
              }
            ]
          },
          {
            "key": "contact_name",
            "question": "Primary Contact Full Name",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "contact_phone",
            "question": "Primary Contact Phone",
            "inputType": "phone",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "contact_email",
            "question": "Primary Contact Email",
            "inputType": "email",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "admissions_phone",
            "question": "Admissions Phone Number",
            "inputType": "phone",
            "required": true,
            "helper": null,
            "options": []
          }
        ]
      },
      {
        "key": "location",
        "title": "Location",
        "helper": null,
        "questions": [
          {
            "key": "street_address",
            "question": "Street Address",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "city",
            "question": "City",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "state",
            "question": "State",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "postal_code",
            "question": "ZIP Code",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "county_region",
            "question": "County/Region",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "capacity",
            "question": "Capacity",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          }
        ]
      },
      {
        "key": "care",
        "title": "Level of Care & Substances",
        "helper": null,
        "questions": [
          {
            "key": "asam_level",
            "question": "ASAM Level",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "46074796-5dbc-4905-b3ed-2570a91cb9e6",
                "label": "3.5"
              },
              {
                "taxonomyId": "02352c58-949f-423d-b6a6-adea98c46360",
                "label": "3.7"
              },
              {
                "taxonomyId": "9229d24a-a3b3-4fec-972d-69f701547766",
                "label": "4.0"
              }
            ]
          },
          {
            "key": "substances",
            "question": "What Substances Do You Provide Medically Supervised DTX For",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "9674b0e7-585b-4d06-8560-2730f9e9ccf3",
                "label": "Alcohol"
              },
              {
                "taxonomyId": "a1705bb3-c90f-4233-a812-3af1923962ea",
                "label": "Benzodiazepines"
              },
              {
                "taxonomyId": "06eb3ba2-0a06-4fc5-ad9e-b4ec7a347f05",
                "label": "Cannabis"
              },
              {
                "taxonomyId": "ebfec50c-e8ea-4de0-8061-793592c52dd0",
                "label": "Hallucinogens"
              },
              {
                "taxonomyId": "9682bd64-c831-458e-a95d-772672297546",
                "label": "Inhalants"
              },
              {
                "taxonomyId": "b2ddc795-94bf-4800-9ceb-0060d5cb70dc",
                "label": "Kratom"
              },
              {
                "taxonomyId": "59792d6f-d6bd-401e-9877-de4644955dd0",
                "label": "Methadone"
              },
              {
                "taxonomyId": "d9d629d7-4da6-473c-a8af-abd4a750d2e8",
                "label": "Opioids"
              },
              {
                "taxonomyId": "3a00b7a6-321c-4452-85ff-55871acd4f14",
                "label": "Polysubstance Use"
              },
              {
                "taxonomyId": "40d9b900-de8d-4ee7-bbe4-9d966717d04d",
                "label": "Stimulants (Methamphetamine, Cocaine, Prescription)"
              },
              {
                "taxonomyId": "869d672f-abc5-4aa4-ae72-fe9423c70c91",
                "label": "Synthetic Drugs (K2, Spice, Bath Salts, etc.)"
              }
            ]
          },
          {
            "key": "methadone_max_dose_mg",
            "question": "Please include the highest dose of methadone you will detox in milligrams",
            "inputType": "whole_number",
            "required": true,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "substances",
              "taxonomyId": "59792d6f-d6bd-401e-9877-de4644955dd0"
            }
          }
        ]
      },
      {
        "key": "populations",
        "title": "Populations Served",
        "helper": null,
        "questions": [
          {
            "key": "populations",
            "question": "Populations Served",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "1eaf7812-309c-4457-9dad-cb4fc56a5d34",
                "label": "Adolescents"
              },
              {
                "taxonomyId": "4e779ea8-8174-4d75-a6a6-2a02d1da6206",
                "label": "Adults (18-65)"
              },
              {
                "taxonomyId": "8c1c425a-29fc-42d0-a300-c52eed832238",
                "label": "LGBTQ+"
              },
              {
                "taxonomyId": "2054d240-13cf-4b28-9c07-1333abe30387",
                "label": "Men Only"
              },
              {
                "taxonomyId": "d5191ad0-3d81-42a6-9800-118249c12462",
                "label": "Non Binary"
              },
              {
                "taxonomyId": "0bf99534-4340-4cfc-bc12-a57b4c4e29bc",
                "label": "Older Adults (55-65)"
              },
              {
                "taxonomyId": "a4d7ca76-74b3-4217-95b5-e17831289128",
                "label": "Pregnant Women"
              },
              {
                "taxonomyId": "b91c8293-b3d4-494e-a218-3567d0584412",
                "label": "Seniors (65+)"
              },
              {
                "taxonomyId": "ad25c4b8-f12e-4a51-b199-fbe8498add57",
                "label": "Transgender Female"
              },
              {
                "taxonomyId": "281cbe07-a6ab-497c-ab3d-c073685c727b",
                "label": "Transgender Male"
              },
              {
                "taxonomyId": "9f223a9e-02a8-4e00-a0b4-9f1344f52fa8",
                "label": "Women Only"
              }
            ]
          },
          {
            "key": "age_min",
            "question": "Minimum Age Served",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "age_max",
            "question": "Maximum Age Served",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          }
        ]
      },
      {
        "key": "medical",
        "title": "Medical & Psychiatric",
        "helper": null,
        "questions": [
          {
            "key": "medical_exclusions",
            "question": "Medical Exclusions",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "06e4a85c-cdc0-49fe-9fda-9ac3720c21ff",
                "label": "Active GI Bleed"
              },
              {
                "taxonomyId": "7ba7cd24-2f34-46f6-ab81-ffa8a49e9324",
                "label": "Chest Pain"
              },
              {
                "taxonomyId": "3ff67f53-0e7a-4244-91c9-8daae8f453bc",
                "label": "Dialysis"
              },
              {
                "taxonomyId": "536b73aa-f579-4cd4-bae4-bf2985ddde5d",
                "label": "Dual Taper (Benzo & Bupe)"
              },
              {
                "taxonomyId": "50c57747-b96d-44b9-8683-2d1071af74f1",
                "label": "History of Withdrawal Related Seizures"
              },
              {
                "taxonomyId": "edb35157-1ec5-4726-baf0-abf6a5ff0272",
                "label": "Recent Heart Attack"
              },
              {
                "taxonomyId": "5bed9da4-c70a-48a7-b146-73710aed3d54",
                "label": "Recent Stroke"
              },
              {
                "taxonomyId": "d13f3b6d-16bc-46f3-bcc1-7e91b5192795",
                "label": "Recent Withdrawal Related Seizure"
              },
              {
                "taxonomyId": "6edf11fc-cc30-4fd4-a682-70c14ba866ca",
                "label": "Severe Hypertension"
              },
              {
                "taxonomyId": "528b9342-80d2-4070-8f1c-b32260c2d319",
                "label": "Unstable Diabetes"
              },
              {
                "taxonomyId": "4fdf5053-93de-4603-8ec2-4817273c0d38",
                "label": "Ventilator Dependent"
              },
              {
                "taxonomyId": "5db3aee7-bb26-4b70-975a-3b2a914a9f14",
                "label": "Other (Please Describe)"
              }
            ]
          },
          {
            "key": "other_medical_exclusions",
            "question": "Other Medical Exclusions",
            "inputType": "long_text",
            "required": false,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "medical_exclusions",
              "taxonomyId": "5db3aee7-bb26-4b70-975a-3b2a914a9f14"
            }
          },
          {
            "key": "medical_capabilities",
            "question": "Medical Capabilities",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "db014a67-990b-4c52-9b27-30a9d20fc2d1",
                "label": "24 Hour Nursing"
              },
              {
                "taxonomyId": "07dd292f-feab-4bdd-b8db-fe481176d761",
                "label": "EKG"
              },
              {
                "taxonomyId": "bbfbbe72-af7a-4787-97fe-3298eebad62f",
                "label": "Feeding Tubes"
              },
              {
                "taxonomyId": "b8d3a392-5a41-437c-935e-0fba66ea19cb",
                "label": "IV Fluids"
              },
              {
                "taxonomyId": "4ffc024e-9c69-4882-a2e5-f1549eb4e185",
                "label": "Medication Assisted Treatment"
              },
              {
                "taxonomyId": "d263bba0-48f1-435e-8dfb-5a7c5befbf68",
                "label": "Nurse Practitioner Onsite"
              },
              {
                "taxonomyId": "216e6ca5-64f8-4b52-be40-d1ce7d39a8de",
                "label": "Oxygen Therapy"
              },
              {
                "taxonomyId": "3cf913d5-2737-411e-828a-290839d476e9",
                "label": "Physician Onsite Daily"
              },
              {
                "taxonomyId": "0dfde2e0-94b3-4d8b-941e-166161b5c3eb",
                "label": "Pregnancy Monitoring"
              },
              {
                "taxonomyId": "82517bdc-7dfe-4b30-a826-3d671def8403",
                "label": "Wound Care"
              },
              {
                "taxonomyId": "4e0f8e26-b7a8-4df2-bdae-d718b8e9163c",
                "label": "Other (Please List)"
              }
            ]
          },
          {
            "key": "other_medical_capabilities",
            "question": "Other Medical Capabilities",
            "inputType": "long_text",
            "required": false,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "medical_capabilities",
              "taxonomyId": "4e0f8e26-b7a8-4df2-bdae-d718b8e9163c"
            }
          },
          {
            "key": "psychiatric_capabilities",
            "question": "Psychiatric Capabilities",
            "inputType": "multi_select",
            "required": false,
            "helper": "Can you admit patients with:",
            "options": [
              {
                "taxonomyId": "0d768e15-668b-41c9-9fde-661411f43cc5",
                "label": "Anxiety Disorders"
              },
              {
                "taxonomyId": "52e9338c-fde6-4a74-9466-a625bf9f7f94",
                "label": "Autism Spectrum Disorder (Level 1)"
              },
              {
                "taxonomyId": "6dbe589d-bd91-4d3d-8d63-127b99c84875",
                "label": "Bipolar Disorder"
              },
              {
                "taxonomyId": "58d49f0f-e8eb-472e-9bf4-6a95b41de935",
                "label": "Borderline Personality Disorder"
              },
              {
                "taxonomyId": "41b317ab-d298-4c13-9f03-5488e521fee7",
                "label": "Depression"
              },
              {
                "taxonomyId": "31242786-d019-49fa-b981-d717a4b53338",
                "label": "Eating Disorders"
              },
              {
                "taxonomyId": "5a23b3ba-998d-4124-b1e4-642e515b6cd1",
                "label": "OCD"
              },
              {
                "taxonomyId": "4718fa8d-5468-40ec-a79b-66cb9827a01d",
                "label": "PTSD"
              },
              {
                "taxonomyId": "dd32c1f3-fa2d-4f79-be08-940545f890c4",
                "label": "Schizophrenia/Psychotic Disorders"
              }
            ]
          }
        ]
      },
      {
        "key": "insurance",
        "title": "Insurance & Payment",
        "helper": null,
        "questions": [
          {
            "key": "insurance_in_network",
            "question": "In- Network Insurances Accepted",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000001",
                "label": "Aetna"
              },
              {
                "taxonomyId": "0d261381-1d51-4452-b1a0-d930ca69ba95",
                "label": "Beacon"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000004",
                "label": "Blue Cross Blue Shield"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000002",
                "label": "Cigna"
              },
              {
                "taxonomyId": "7ee4e09d-8926-4d12-be1a-d4e08e83c0a5",
                "label": "DMBA"
              },
              {
                "taxonomyId": "0d1fe02b-0997-4ef1-99e7-25fbfae18eff",
                "label": "EMI"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000005",
                "label": "Humana"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000011",
                "label": "Medicaid"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000012",
                "label": "Medicare"
              },
              {
                "taxonomyId": "5cdeee56-3d5f-4530-9433-09392f8903ad",
                "label": "Motiv Health"
              },
              {
                "taxonomyId": "fb938b4c-7e09-490d-bc91-e08f6d00b56f",
                "label": "PEHP"
              },
              {
                "taxonomyId": "1efdc57e-9385-4416-8ed6-698a51e83e2e",
                "label": "Select Health"
              },
              {
                "taxonomyId": "247103b8-a093-44f9-b1da-5e63b9ab1cb5",
                "label": "TriCare"
              },
              {
                "taxonomyId": "5aab0da0-eddf-4805-991d-737068044841",
                "label": "United Healthcare"
              },
              {
                "taxonomyId": "5e4d676f-0527-4b93-9724-ffbfbb687603",
                "label": "University of Utah Health Plans"
              },
              {
                "taxonomyId": "e563cfb1-e215-49d6-a37f-c4d5561be03d",
                "label": "Wise Provider Networks"
              },
              {
                "taxonomyId": "a18d3b21-e6da-4346-b82f-c64d28c6e664",
                "label": "Other (Please List)"
              }
            ]
          },
          {
            "key": "other_insurance_in_network",
            "question": "Other In-Network Insurances Accepted",
            "inputType": "long_text",
            "required": false,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "insurance_in_network",
              "taxonomyId": "a18d3b21-e6da-4346-b82f-c64d28c6e664"
            }
          },
          {
            "key": "insurance_out_of_network",
            "question": "Out Of Network Insurance Accepted",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000001",
                "label": "Aetna"
              },
              {
                "taxonomyId": "bbb17b54-8598-41dc-8fda-6556754f06ee",
                "label": "Ambetter"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000004",
                "label": "BlueCross BlueShield"
              },
              {
                "taxonomyId": "7ee4e09d-8926-4d12-be1a-d4e08e83c0a5",
                "label": "DMBA"
              },
              {
                "taxonomyId": "0d1fe02b-0997-4ef1-99e7-25fbfae18eff",
                "label": "EMI"
              },
              {
                "taxonomyId": "cb32b5c5-0ca0-4a36-8bd0-633b924d8a2e",
                "label": "GEHA"
              },
              {
                "taxonomyId": "a6b5f71b-1327-48c7-910a-75a10e035b5a",
                "label": "Molina"
              },
              {
                "taxonomyId": "5cdeee56-3d5f-4530-9433-09392f8903ad",
                "label": "Motiv"
              },
              {
                "taxonomyId": "fb938b4c-7e09-490d-bc91-e08f6d00b56f",
                "label": "PEHP"
              },
              {
                "taxonomyId": "1efdc57e-9385-4416-8ed6-698a51e83e2e",
                "label": "Select Health"
              },
              {
                "taxonomyId": "8117fa8c-c0d2-49c4-ab8d-38e926113f30",
                "label": "UMR"
              },
              {
                "taxonomyId": "5aab0da0-eddf-4805-991d-737068044841",
                "label": "United Healthcare"
              },
              {
                "taxonomyId": "a18d3b21-e6da-4346-b82f-c64d28c6e664",
                "label": "Other (Please List)"
              }
            ]
          },
          {
            "key": "other_insurance_out_of_network",
            "question": "Other Out-of-Network Insurances Accepted",
            "inputType": "long_text",
            "required": false,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "insurance_out_of_network",
              "taxonomyId": "a18d3b21-e6da-4346-b82f-c64d28c6e664"
            }
          },
          {
            "key": "payment_options",
            "question": "Payment Options",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "e8a1f176-bf40-48fb-98ed-c7e75e207b20",
                "label": "Out-of-Network Insurance"
              },
              {
                "taxonomyId": "5901a15b-32c5-49a4-a9b5-b5283c344cea",
                "label": "Payment Plans"
              },
              {
                "taxonomyId": "c6424300-10ba-4e97-8939-116bc367bcce",
                "label": "Private Insurance"
              },
              {
                "taxonomyId": "fcb11990-4124-465b-a203-62eb1c4eb932",
                "label": "Scholarships"
              },
              {
                "taxonomyId": "7ed6adf8-589b-4cc3-b4e7-23e55ede31fd",
                "label": "Self-Pay"
              },
              {
                "taxonomyId": "4e2d5241-2e9d-4bc5-8955-2008931440a3",
                "label": "Sliding Scale"
              }
            ]
          },
          {
            "key": "self_pay_daily_rate",
            "question": "Self Pay Daily Rate",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          }
        ]
      },
      {
        "key": "additional",
        "title": "Additional Program Details",
        "helper": null,
        "questions": [
          {
            "key": "additional_details",
            "question": "Additional Program Details- Things that make you unique. Amenities, Services, Etc.",
            "inputType": "long_text",
            "required": false,
            "helper": null,
            "options": []
          }
        ]
      }
    ]
  },
  "outpatient": {
    "source": "outpatient",
    "title": "MatchPoint Provider Profile (Outpatient)",
    "estimate": "15-25 minutes",
    "sections": [
      {
        "key": "location",
        "title": "Location & Address",
        "helper": null,
        "questions": [
          {
            "key": "program_name",
            "question": "Program Name",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "provider_type",
            "question": "Provider Type",
            "inputType": "single_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "bac79862-434e-4c3d-bdcd-60050def06d6",
                "label": "Detox"
              },
              {
                "taxonomyId": "b1b8cee0-d2c1-4e68-9723-91acad9b114f",
                "label": "GOP"
              },
              {
                "taxonomyId": "cada2901-f8c7-42ed-888d-7bcdea5bc486",
                "label": "Hospital"
              },
              {
                "taxonomyId": "03ca8d3c-71a7-442a-8617-c895330a4111",
                "label": "IOP"
              },
              {
                "taxonomyId": "59e4f7e9-3ad3-4990-beda-b55e38b6ef74",
                "label": "Individual Therapist"
              },
              {
                "taxonomyId": "9cc248da-211c-4b5f-a5d5-8bc14af291b9",
                "label": "Outpatient"
              },
              {
                "taxonomyId": "15ed97b3-ae3e-418e-bbc6-97422cc3e08e",
                "label": "PHP"
              },
              {
                "taxonomyId": "078c106b-49fe-4987-b74c-cd9d7c515791",
                "label": "Private Practice Therapist"
              },
              {
                "taxonomyId": "1a3ecf9a-2cc7-48d7-a7c2-2c393670540d",
                "label": "Residential"
              },
              {
                "taxonomyId": "1759b382-3312-4b23-8178-3c3ed96e8385",
                "label": "Sober Living"
              },
              {
                "taxonomyId": "82a6b779-4615-4bcd-9c51-56f20ab68402",
                "label": "Standalone Hospital"
              },
              {
                "taxonomyId": "180a1e8b-bf34-4972-bc11-fef740c21c6a",
                "label": "Virtual Only"
              }
            ]
          },
          {
            "key": "street_address",
            "question": "Address",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "city",
            "question": "City",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "state",
            "question": "State",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "postal_code",
            "question": "ZIP Code",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "county_region",
            "question": "County/Region",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          }
        ]
      },
      {
        "key": "levels",
        "title": "Levels of Care",
        "helper": null,
        "questions": [
          {
            "key": "levels_of_care",
            "question": "Levels of Care Offered at this Location",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "ff8d3dcd-351e-4e4a-8ab7-8ae2d40947d3",
                "label": "GOP"
              },
              {
                "taxonomyId": "6a980d67-5e9c-4a75-9454-7772f872a0bd",
                "label": "IOP"
              },
              {
                "taxonomyId": "c23481aa-ae1c-47bd-a1ff-68b8bc2846cf",
                "label": "Medical Detox"
              },
              {
                "taxonomyId": "d13a0487-53cf-42fd-8df8-9f2e33ce07c9",
                "label": "PHP"
              },
              {
                "taxonomyId": "55e2778e-48fb-4683-8f9e-6f6f1f84cec0",
                "label": "RTC"
              },
              {
                "taxonomyId": "b9790b44-5a7b-4261-8d88-c3ed9b3f0b05",
                "label": "Sober Living/Supportive Housing"
              },
              {
                "taxonomyId": "932d4fde-6bcb-4abb-a6c1-a1b1a38ac645",
                "label": "Social Detox"
              }
            ]
          },
          {
            "key": "php_length_weeks",
            "question": "PHP Length of Program (in weeks)",
            "inputType": "whole_number",
            "required": true,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "levels_of_care",
              "taxonomyId": "d13a0487-53cf-42fd-8df8-9f2e33ce07c9"
            }
          },
          {
            "key": "php_schedule",
            "question": "PHP Schedule",
            "inputType": "weekly_schedule",
            "required": true,
            "helper": "The days of the week and hours the program meets.",
            "options": [],
            "revealedBy": {
              "questionKey": "levels_of_care",
              "taxonomyId": "d13a0487-53cf-42fd-8df8-9f2e33ce07c9"
            }
          },
          {
            "key": "iop_length_weeks",
            "question": "IOP Length of Program (in weeks)",
            "inputType": "whole_number",
            "required": true,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "levels_of_care",
              "taxonomyId": "6a980d67-5e9c-4a75-9454-7772f872a0bd"
            }
          },
          {
            "key": "iop_schedule",
            "question": "IOP Schedule",
            "inputType": "weekly_schedule",
            "required": true,
            "helper": "Add a track for each schedule you run, such as a daytime and an evening group.",
            "options": [],
            "revealedBy": {
              "questionKey": "levels_of_care",
              "taxonomyId": "6a980d67-5e9c-4a75-9454-7772f872a0bd"
            }
          },
          {
            "key": "iop_attendance",
            "question": "IOP Attendance",
            "inputType": "single_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "1531e60c-5025-44a3-b7e1-1bce7f53030b",
                "label": "In-Person"
              },
              {
                "taxonomyId": "60dc71d9-b505-4922-bbbc-6113d226db0c",
                "label": "Virtual"
              },
              {
                "taxonomyId": "af474dc2-2cc9-4bee-9cea-cf99b70e46f4",
                "label": "Hybrid (can attend a combo of in-person and virtual)"
              }
            ],
            "revealedBy": {
              "questionKey": "levels_of_care",
              "taxonomyId": "6a980d67-5e9c-4a75-9454-7772f872a0bd"
            }
          },
          {
            "key": "gop_length_weeks",
            "question": "GOP Length of Program (in weeks)",
            "inputType": "whole_number",
            "required": true,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "levels_of_care",
              "taxonomyId": "ff8d3dcd-351e-4e4a-8ab7-8ae2d40947d3"
            }
          }
        ]
      },
      {
        "key": "contact",
        "title": "Primary Contact Information",
        "helper": null,
        "questions": [
          {
            "key": "contact_name",
            "question": "Primary Contact Name",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "contact_phone",
            "question": "Primary Contact Phone",
            "inputType": "phone",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "contact_email",
            "question": "Primary Contact Email",
            "inputType": "email",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "contact_title",
            "question": "Primary Contact Title",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "admissions_phone",
            "question": "Admissions Phone Number",
            "inputType": "phone",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "contact_linkedin",
            "question": "Primary Contact LinkedIn",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          }
        ]
      },
      {
        "key": "insurance",
        "title": "Insurance & Payment",
        "helper": null,
        "questions": [
          {
            "key": "payment_options",
            "question": "Payment Options",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "e8a1f176-bf40-48fb-98ed-c7e75e207b20",
                "label": "Out-of-Network Insurance"
              },
              {
                "taxonomyId": "5901a15b-32c5-49a4-a9b5-b5283c344cea",
                "label": "Payment Plans"
              },
              {
                "taxonomyId": "c6424300-10ba-4e97-8939-116bc367bcce",
                "label": "Private Insurance"
              },
              {
                "taxonomyId": "fcb11990-4124-465b-a203-62eb1c4eb932",
                "label": "Scholarships"
              },
              {
                "taxonomyId": "7ed6adf8-589b-4cc3-b4e7-23e55ede31fd",
                "label": "Self-Pay"
              },
              {
                "taxonomyId": "4e2d5241-2e9d-4bc5-8955-2008931440a3",
                "label": "Sliding Scale"
              }
            ]
          },
          {
            "key": "self_pay_rate_php",
            "question": "Self Pay Rate PHP",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "levels_of_care",
              "taxonomyId": "d13a0487-53cf-42fd-8df8-9f2e33ce07c9"
            }
          },
          {
            "key": "self_pay_rate_iop",
            "question": "Self Pay Rate IOP",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "levels_of_care",
              "taxonomyId": "6a980d67-5e9c-4a75-9454-7772f872a0bd"
            }
          },
          {
            "key": "insurance_in_network",
            "question": "In-Network Insurances Accepted",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000001",
                "label": "Aetna"
              },
              {
                "taxonomyId": "0d261381-1d51-4452-b1a0-d930ca69ba95",
                "label": "Beacon"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000004",
                "label": "Blue Cross Blue Shield"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000002",
                "label": "Cigna"
              },
              {
                "taxonomyId": "7ee4e09d-8926-4d12-be1a-d4e08e83c0a5",
                "label": "DMBA"
              },
              {
                "taxonomyId": "0d1fe02b-0997-4ef1-99e7-25fbfae18eff",
                "label": "EMI"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000005",
                "label": "Humana"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000011",
                "label": "Medicaid"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000012",
                "label": "Medicare"
              },
              {
                "taxonomyId": "5cdeee56-3d5f-4530-9433-09392f8903ad",
                "label": "Motiv Health"
              },
              {
                "taxonomyId": "fb938b4c-7e09-490d-bc91-e08f6d00b56f",
                "label": "PEHP"
              },
              {
                "taxonomyId": "1efdc57e-9385-4416-8ed6-698a51e83e2e",
                "label": "Select Health"
              },
              {
                "taxonomyId": "247103b8-a093-44f9-b1da-5e63b9ab1cb5",
                "label": "TriCare"
              },
              {
                "taxonomyId": "5aab0da0-eddf-4805-991d-737068044841",
                "label": "United Healthcare"
              },
              {
                "taxonomyId": "5e4d676f-0527-4b93-9724-ffbfbb687603",
                "label": "University of Utah Health Plans"
              },
              {
                "taxonomyId": "e563cfb1-e215-49d6-a37f-c4d5561be03d",
                "label": "Wise Provider Networks"
              },
              {
                "taxonomyId": "a18d3b21-e6da-4346-b82f-c64d28c6e664",
                "label": "Other"
              }
            ]
          },
          {
            "key": "insurance_out_of_network",
            "question": "Out of Network Insurance Accepted",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000001",
                "label": "Aetna"
              },
              {
                "taxonomyId": "bbb17b54-8598-41dc-8fda-6556754f06ee",
                "label": "Ambetter"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000004",
                "label": "BlueCross BlueShield"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000002",
                "label": "Cigna"
              },
              {
                "taxonomyId": "7ee4e09d-8926-4d12-be1a-d4e08e83c0a5",
                "label": "DMBA"
              },
              {
                "taxonomyId": "0d1fe02b-0997-4ef1-99e7-25fbfae18eff",
                "label": "EMI"
              },
              {
                "taxonomyId": "cb32b5c5-0ca0-4a36-8bd0-633b924d8a2e",
                "label": "GEHA"
              },
              {
                "taxonomyId": "a6b5f71b-1327-48c7-910a-75a10e035b5a",
                "label": "Molina"
              },
              {
                "taxonomyId": "5cdeee56-3d5f-4530-9433-09392f8903ad",
                "label": "Motiv"
              },
              {
                "taxonomyId": "fb938b4c-7e09-490d-bc91-e08f6d00b56f",
                "label": "PEHP"
              },
              {
                "taxonomyId": "1efdc57e-9385-4416-8ed6-698a51e83e2e",
                "label": "Select Health"
              },
              {
                "taxonomyId": "8117fa8c-c0d2-49c4-ab8d-38e926113f30",
                "label": "UMR"
              },
              {
                "taxonomyId": "5aab0da0-eddf-4805-991d-737068044841",
                "label": "United Healthcare"
              }
            ]
          }
        ]
      },
      {
        "key": "populations",
        "title": "Populations Served",
        "helper": null,
        "questions": [
          {
            "key": "populations",
            "question": "Populations Served",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "1eaf7812-309c-4457-9dad-cb4fc56a5d34",
                "label": "Adolescents"
              },
              {
                "taxonomyId": "4e779ea8-8174-4d75-a6a6-2a02d1da6206",
                "label": "Adults (18-65)"
              },
              {
                "taxonomyId": "bfd37354-cd0f-45f6-99a1-61fd460241eb",
                "label": "Children"
              },
              {
                "taxonomyId": "bddfd045-3189-4448-84eb-951ce3a01fa5",
                "label": "Couples"
              },
              {
                "taxonomyId": "c530351a-d438-425d-b2cf-30f776571c2a",
                "label": "Gender Specific"
              },
              {
                "taxonomyId": "8c1c425a-29fc-42d0-a300-c52eed832238",
                "label": "LGBTQ+"
              },
              {
                "taxonomyId": "2054d240-13cf-4b28-9c07-1333abe30387",
                "label": "Men Only"
              },
              {
                "taxonomyId": "d5191ad0-3d81-42a6-9800-118249c12462",
                "label": "Non Binary"
              },
              {
                "taxonomyId": "0bf99534-4340-4cfc-bc12-a57b4c4e29bc",
                "label": "Older Adults (55-65)"
              },
              {
                "taxonomyId": "a4d7ca76-74b3-4217-95b5-e17831289128",
                "label": "Pregnant Women"
              },
              {
                "taxonomyId": "b91c8293-b3d4-494e-a218-3567d0584412",
                "label": "Seniors (65+)"
              },
              {
                "taxonomyId": "ad25c4b8-f12e-4a51-b199-fbe8498add57",
                "label": "Transgender Female"
              },
              {
                "taxonomyId": "281cbe07-a6ab-497c-ab3d-c073685c727b",
                "label": "Transgender Male"
              },
              {
                "taxonomyId": "7142e438-0bef-46df-8cb9-317b2df5def7",
                "label": "Veterans"
              },
              {
                "taxonomyId": "ef90ca8a-51ce-4db0-9527-036a86d2f5c8",
                "label": "Women"
              },
              {
                "taxonomyId": "9f223a9e-02a8-4e00-a0b4-9f1344f52fa8",
                "label": "Women Only"
              },
              {
                "taxonomyId": "4ecf1203-152f-4867-b6b9-3c2b6c40cf8f",
                "label": "Young Adults (18-28)"
              },
              {
                "taxonomyId": "47452594-c3bd-4909-82e5-7fb8f1599765",
                "label": "Other"
              }
            ]
          },
          {
            "key": "age_min",
            "question": "Minimum Age Served",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "age_max",
            "question": "Maximum Age Served",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          }
        ]
      },
      {
        "key": "diagnoses",
        "title": "Diagnoses (Treated & Exclusionary)",
        "helper": null,
        "questions": [
          {
            "key": "diagnoses_accepted",
            "question": "Diagnoses Treated",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "2381db0f-f4f5-4cd5-812f-b44858c7695d",
                "label": "ADD/ADHD"
              },
              {
                "taxonomyId": "2eb9f532-2d70-43ea-9ed3-10d74069415d",
                "label": "Alcohol Use Disorder"
              },
              {
                "taxonomyId": "0be0a8a6-5350-46cd-bd11-6eb343dff15e",
                "label": "Anxiety"
              },
              {
                "taxonomyId": "e2046bac-5ef8-47c0-adf7-befb155b2ae1",
                "label": "Autism Spectrum Disorder"
              },
              {
                "taxonomyId": "6dbe589d-bd91-4d3d-8d63-127b99c84875",
                "label": "Bipolar Disorder"
              },
              {
                "taxonomyId": "58d49f0f-e8eb-472e-9bf4-6a95b41de935",
                "label": "Borderline Personality Disorder (BPD)"
              },
              {
                "taxonomyId": "4cf731fd-d5e4-4ef2-a121-8987d767f012",
                "label": "Co-occurring Disorders"
              },
              {
                "taxonomyId": "41b317ab-d298-4c13-9f03-5488e521fee7",
                "label": "Depression"
              },
              {
                "taxonomyId": "1d0d8f5f-98a4-4fd5-86ba-8187aad6abc8",
                "label": "Dissociative Identity Disorder (DID)"
              },
              {
                "taxonomyId": "31242786-d019-49fa-b981-d717a4b53338",
                "label": "Eating Disorders"
              },
              {
                "taxonomyId": "a0d7785f-6fc5-4581-828a-d42f2cf9934b",
                "label": "Homicidal ideation"
              },
              {
                "taxonomyId": "5a23b3ba-998d-4124-b1e4-642e515b6cd1",
                "label": "OCD"
              },
              {
                "taxonomyId": "a9f80a6d-ca73-468f-82a2-3f888620de1f",
                "label": "Opioid Use Disorder"
              },
              {
                "taxonomyId": "4718fa8d-5468-40ec-a79b-66cb9827a01d",
                "label": "PTSD"
              },
              {
                "taxonomyId": "214fee14-8299-41e6-bcee-dac59aa04f0e",
                "label": "Personality Disorders"
              },
              {
                "taxonomyId": "4fb74ce6-74d5-4454-9b08-8705dcea433e",
                "label": "Post Pardum"
              },
              {
                "taxonomyId": "3debf016-7fd4-40e9-9773-efdf58eb8360",
                "label": "Schizoaffective"
              },
              {
                "taxonomyId": "46b7c83c-e71f-4cb6-9891-6efa9627373d",
                "label": "Schizophrenia"
              },
              {
                "taxonomyId": "ebf3b8d1-7d5a-4270-92c5-57a940fa7174",
                "label": "Self-Harm"
              },
              {
                "taxonomyId": "53e2dc1a-77c2-4634-8c37-bdc29f7dba3f",
                "label": "Substance Use Disorder"
              },
              {
                "taxonomyId": "cc09c8ce-e576-4c13-83e7-308949da4cea",
                "label": "Suicide Attempt (Last 90 Days)"
              },
              {
                "taxonomyId": "2c43450a-4a3b-4af5-9ec5-4b9e38144115",
                "label": "Trauma"
              },
              {
                "taxonomyId": "246e88f2-1b91-45df-b773-5bfa586a603a",
                "label": "Violence Towards Healthcare Staff"
              },
              {
                "taxonomyId": "2544a962-b47d-4e79-8faa-f868c082c7b4",
                "label": "Other"
              }
            ]
          },
          {
            "key": "exclusionary_criteria",
            "question": "Exclusionary Diagnoses",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "2381db0f-f4f5-4cd5-812f-b44858c7695d",
                "label": "ADD/ADHD"
              },
              {
                "taxonomyId": "2eb9f532-2d70-43ea-9ed3-10d74069415d",
                "label": "Alcohol Use Disorder"
              },
              {
                "taxonomyId": "0be0a8a6-5350-46cd-bd11-6eb343dff15e",
                "label": "Anxiety"
              },
              {
                "taxonomyId": "e2046bac-5ef8-47c0-adf7-befb155b2ae1",
                "label": "Autism Spectrum Disorder"
              },
              {
                "taxonomyId": "6dbe589d-bd91-4d3d-8d63-127b99c84875",
                "label": "Bipolar Disorder"
              },
              {
                "taxonomyId": "58d49f0f-e8eb-472e-9bf4-6a95b41de935",
                "label": "Borderline Personality Disorder (BPD)"
              },
              {
                "taxonomyId": "4cf731fd-d5e4-4ef2-a121-8987d767f012",
                "label": "Co-occurring Disorders"
              },
              {
                "taxonomyId": "41b317ab-d298-4c13-9f03-5488e521fee7",
                "label": "Depression"
              },
              {
                "taxonomyId": "1d0d8f5f-98a4-4fd5-86ba-8187aad6abc8",
                "label": "Dissociative Identity Disorder (DID)"
              },
              {
                "taxonomyId": "31242786-d019-49fa-b981-d717a4b53338",
                "label": "Eating Disorders"
              },
              {
                "taxonomyId": "a0d7785f-6fc5-4581-828a-d42f2cf9934b",
                "label": "Homicidal ideation"
              },
              {
                "taxonomyId": "5a23b3ba-998d-4124-b1e4-642e515b6cd1",
                "label": "OCD"
              },
              {
                "taxonomyId": "a9f80a6d-ca73-468f-82a2-3f888620de1f",
                "label": "Opioid Use Disorder"
              },
              {
                "taxonomyId": "4718fa8d-5468-40ec-a79b-66cb9827a01d",
                "label": "PTSD"
              },
              {
                "taxonomyId": "214fee14-8299-41e6-bcee-dac59aa04f0e",
                "label": "Personality Disorders"
              },
              {
                "taxonomyId": "3debf016-7fd4-40e9-9773-efdf58eb8360",
                "label": "Schizoaffective"
              },
              {
                "taxonomyId": "46b7c83c-e71f-4cb6-9891-6efa9627373d",
                "label": "Schizophrenia"
              },
              {
                "taxonomyId": "ebf3b8d1-7d5a-4270-92c5-57a940fa7174",
                "label": "Self-Harm"
              },
              {
                "taxonomyId": "53e2dc1a-77c2-4634-8c37-bdc29f7dba3f",
                "label": "Substance Use Disorder"
              },
              {
                "taxonomyId": "cc09c8ce-e576-4c13-83e7-308949da4cea",
                "label": "Suicide Attempt (Last 90 Days)"
              },
              {
                "taxonomyId": "2c43450a-4a3b-4af5-9ec5-4b9e38144115",
                "label": "Trauma"
              },
              {
                "taxonomyId": "246e88f2-1b91-45df-b773-5bfa586a603a",
                "label": "Violence Towards Healthcare Staff"
              },
              {
                "taxonomyId": "2544a962-b47d-4e79-8faa-f868c082c7b4",
                "label": "Other"
              }
            ]
          }
        ]
      },
      {
        "key": "modalities",
        "title": "Modalities Offered",
        "helper": null,
        "questions": [
          {
            "key": "modalities",
            "question": "Modalities Offered",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "c0348c95-418b-4991-a020-0f7e1db256b6",
                "label": "12-Step"
              },
              {
                "taxonomyId": "16a2e235-a69b-4874-bf79-b12ff45e5d1f",
                "label": "Adventure Based Therapy"
              },
              {
                "taxonomyId": "94e949d4-3eb9-4aa0-b927-1bcde34b2910",
                "label": "Brain Spotting"
              },
              {
                "taxonomyId": "e65cd9c6-08dc-4655-88ab-369c98dd32a2",
                "label": "CAMS (Suicide Prevention)"
              },
              {
                "taxonomyId": "20789687-0357-463d-8545-7e3989ac2ccf",
                "label": "CBT"
              },
              {
                "taxonomyId": "19cca206-453b-45df-9ddf-81747913e3af",
                "label": "DBT"
              },
              {
                "taxonomyId": "acbfa08c-9119-4b31-89bc-a58de6ed1c0f",
                "label": "DBT for Eating Disorders"
              },
              {
                "taxonomyId": "aa706d06-e152-4fe5-a5e9-16960a17a63c",
                "label": "DBT for Psychosis"
              },
              {
                "taxonomyId": "cd08a7eb-5f4f-4e37-ba7f-b4d9b41b2701",
                "label": "DBT-Prolonged Exposure"
              },
              {
                "taxonomyId": "993a25c7-3cbe-416c-a264-f78a24418010",
                "label": "EMDR"
              },
              {
                "taxonomyId": "9d3ad229-30f2-471f-bfcc-9cff0e47c001",
                "label": "Equine Therapy"
              },
              {
                "taxonomyId": "759a1b43-6c14-4080-8aed-8c4b11ba0296",
                "label": "Exposure and Response Prevention (ERP)"
              },
              {
                "taxonomyId": "57ea2975-bf27-49dc-9d9d-696f304a7872",
                "label": "Family Therapy"
              },
              {
                "taxonomyId": "61dbf384-7821-48a0-8b67-54d32d07d8e7",
                "label": "Group Therapy"
              },
              {
                "taxonomyId": "6e517743-009a-4626-901d-08d6603587d1",
                "label": "Holistic"
              },
              {
                "taxonomyId": "38ca35d6-2393-4a6f-a54f-4327784563bf",
                "label": "Individual Counseling"
              },
              {
                "taxonomyId": "ee38a62e-cb8d-472c-be9a-9a3fdc409d55",
                "label": "Ketamine Therapy"
              },
              {
                "taxonomyId": "5090533c-adc3-4f7c-86cf-d6f9c24c64e9",
                "label": "Medication-Assisted Treatment"
              },
              {
                "taxonomyId": "a20e5c96-1118-4a3f-88ed-b960d9c09204",
                "label": "Mentoring"
              },
              {
                "taxonomyId": "a7f67f22-bba5-464d-85ef-0882ec93673e",
                "label": "Mindfulness"
              },
              {
                "taxonomyId": "f2905b82-d3e1-4dc2-a357-ab5a73a7fcaa",
                "label": "Motivational Interviewing"
              },
              {
                "taxonomyId": "0bcea5ed-4449-4e0f-a0e7-11a9a3b009d2",
                "label": "Neurolinguistic processing (NLP)"
              },
              {
                "taxonomyId": "fbb92d9a-7d90-4963-ac65-8a74028ab5f1",
                "label": "Peer Support"
              },
              {
                "taxonomyId": "d13d4208-f070-4812-893d-08502faf3fc6",
                "label": "Play Therapy"
              },
              {
                "taxonomyId": "12c18e6d-7a56-47f4-9076-a35cd0c5881c",
                "label": "Prolonged Exposure"
              },
              {
                "taxonomyId": "f7f43d0e-e676-4af0-bc08-08960f43154d",
                "label": "Recreational Therapy"
              },
              {
                "taxonomyId": "962542fa-6fc1-4c6c-8287-01e784ba9210",
                "label": "Seeking Safety"
              },
              {
                "taxonomyId": "8cf6cbe8-b441-4ded-a4ec-a8ccc181e980",
                "label": "Therapeutic Community"
              },
              {
                "taxonomyId": "4b26a1aa-3eae-4935-b7c3-212819576084",
                "label": "Transcranial Magnetic Stimulation (TMS)"
              },
              {
                "taxonomyId": "83c35059-9478-49de-b25d-5028addefc17",
                "label": "Trauma-Informed Care"
              },
              {
                "taxonomyId": "1deee738-ef88-4724-9e01-3e6bea5a57b7",
                "label": "Other"
              }
            ]
          }
        ]
      },
      {
        "key": "additional",
        "title": "Additional Program Details",
        "helper": null,
        "questions": [
          {
            "key": "additional_details",
            "question": "Additional Program Details",
            "inputType": "long_text",
            "required": false,
            "helper": "Please use this to highlight features that you think makes your program unique or to include any information that you feel was missed.",
            "options": []
          }
        ]
      }
    ]
  },
  "residential": {
    "source": "residential",
    "title": "MatchPoint Provider Profile (RTC)",
    "estimate": "15-25 minutes",
    "sections": [
      {
        "key": "location",
        "title": "Location & Address",
        "helper": null,
        "questions": [
          {
            "key": "program_name",
            "question": "Program Name",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "provider_type",
            "question": "Provider Type",
            "inputType": "single_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "1a3ecf9a-2cc7-48d7-a7c2-2c393670540d",
                "label": "Residential"
              },
              {
                "taxonomyId": "4e70dbd9-d594-42d1-9cf1-ee8c4f02318f",
                "label": "School"
              },
              {
                "taxonomyId": "bc52947c-f82b-4878-983a-a7e0dfac87c0",
                "label": "Student Housing"
              },
              {
                "taxonomyId": "3f5af506-59f8-4735-9dd4-d07bd777d8a0",
                "label": "Other"
              }
            ]
          },
          {
            "key": "street_address",
            "question": "Street Address",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "city",
            "question": "City",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "state",
            "question": "State",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "postal_code",
            "question": "ZIP Code",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "county_region",
            "question": "County/Region",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "other_levels_of_care",
            "question": "Other Levels of Care Offered at this location",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "ff8d3dcd-351e-4e4a-8ab7-8ae2d40947d3",
                "label": "GOP"
              },
              {
                "taxonomyId": "6a980d67-5e9c-4a75-9454-7772f872a0bd",
                "label": "IOP"
              },
              {
                "taxonomyId": "c23481aa-ae1c-47bd-a1ff-68b8bc2846cf",
                "label": "Medical Detox"
              },
              {
                "taxonomyId": "d13a0487-53cf-42fd-8df8-9f2e33ce07c9",
                "label": "PHP"
              },
              {
                "taxonomyId": "1759b382-3312-4b23-8178-3c3ed96e8385",
                "label": "Sober Living"
              },
              {
                "taxonomyId": "932d4fde-6bcb-4abb-a6c1-a1b1a38ac645",
                "label": "Social Detox"
              }
            ]
          }
        ]
      },
      {
        "key": "contact",
        "title": "Primary Contact Information",
        "helper": "Main program contact for referrals or questions. i.e. Business Development or Admissions Director.",
        "questions": [
          {
            "key": "contact_name",
            "question": "Primary Contact Name",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "contact_email",
            "question": "Primary Contact Email",
            "inputType": "email",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "contact_phone",
            "question": "Primary Contact Phone",
            "inputType": "phone",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "admissions_phone",
            "question": "Admissions Phone Number",
            "inputType": "phone",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "contact_title",
            "question": "Primary Contact Title",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "contact_linkedin",
            "question": "Primary Contact LinkedIn",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          }
        ]
      },
      {
        "key": "treatment",
        "title": "Treatment, Modalities & Populations",
        "helper": "Please Clarify With Your Clinical Team if Needed.",
        "questions": [
          {
            "key": "modalities",
            "question": "Modalities Offered",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "c0348c95-418b-4991-a020-0f7e1db256b6",
                "label": "12-Step"
              },
              {
                "taxonomyId": "c9c9a910-b2f0-4792-af74-e49e6aee10ee",
                "label": "Acceptance & Commitment Therapy (ACT)"
              },
              {
                "taxonomyId": "0eef7208-0a92-4bb0-b4c1-3f97c21349e8",
                "label": "Adventure Therapy"
              },
              {
                "taxonomyId": "18d1a05e-00e1-442c-9fcb-868dc0ffddbf",
                "label": "Art Therapy"
              },
              {
                "taxonomyId": "94e949d4-3eb9-4aa0-b927-1bcde34b2910",
                "label": "Brain Spotting"
              },
              {
                "taxonomyId": "e65cd9c6-08dc-4655-88ab-369c98dd32a2",
                "label": "CAMS (Suicide Prevention)"
              },
              {
                "taxonomyId": "c4203e48-0343-44cc-a13d-dba3cc9ae4e9",
                "label": "Case Management"
              },
              {
                "taxonomyId": "20789687-0357-463d-8545-7e3989ac2ccf",
                "label": "Cognitive Behavioral Therapy (CBT)"
              },
              {
                "taxonomyId": "0c5208c1-3dd9-4576-8709-f4ccddb6c678",
                "label": "Cognitive Processing Therapy (CPT)"
              },
              {
                "taxonomyId": "acbfa08c-9119-4b31-89bc-a58de6ed1c0f",
                "label": "DBT for Eating Disorders"
              },
              {
                "taxonomyId": "aa706d06-e152-4fe5-a5e9-16960a17a63c",
                "label": "DBT for Psychosis"
              },
              {
                "taxonomyId": "cd08a7eb-5f4f-4e37-ba7f-b4d9b41b2701",
                "label": "DBT-Prolonged Exposure"
              },
              {
                "taxonomyId": "19cca206-453b-45df-9ddf-81747913e3af",
                "label": "Dialectical Behavioral Therapy (DBT)"
              },
              {
                "taxonomyId": "993a25c7-3cbe-416c-a264-f78a24418010",
                "label": "EMDR"
              },
              {
                "taxonomyId": "9d3ad229-30f2-471f-bfcc-9cff0e47c001",
                "label": "Equine Therapy"
              },
              {
                "taxonomyId": "759a1b43-6c14-4080-8aed-8c4b11ba0296",
                "label": "Exposure and Response Prevention (ERP)"
              },
              {
                "taxonomyId": "57ea2975-bf27-49dc-9d9d-696f304a7872",
                "label": "Family Therapy"
              },
              {
                "taxonomyId": "61dbf384-7821-48a0-8b67-54d32d07d8e7",
                "label": "Group Therapy"
              },
              {
                "taxonomyId": "9874a12d-ebdd-4f72-965c-179f238a49aa",
                "label": "Internal Family Systems (IFS)"
              },
              {
                "taxonomyId": "5090533c-adc3-4f7c-86cf-d6f9c24c64e9",
                "label": "Medication-Assisted Treatment"
              },
              {
                "taxonomyId": "a20e5c96-1118-4a3f-88ed-b960d9c09204",
                "label": "Mentoring"
              },
              {
                "taxonomyId": "a7f67f22-bba5-464d-85ef-0882ec93673e",
                "label": "Mindfulness"
              },
              {
                "taxonomyId": "f2905b82-d3e1-4dc2-a357-ab5a73a7fcaa",
                "label": "Motivational Interviewing (MI)"
              },
              {
                "taxonomyId": "1c92597a-97ff-4cf5-9086-0c451381e2cf",
                "label": "Music Therapy"
              },
              {
                "taxonomyId": "0bcea5ed-4449-4e0f-a0e7-11a9a3b009d2",
                "label": "Neurolinguistic processing (NLP)"
              },
              {
                "taxonomyId": "fbb92d9a-7d90-4963-ac65-8a74028ab5f1",
                "label": "Peer Support"
              },
              {
                "taxonomyId": "d13d4208-f070-4812-893d-08502faf3fc6",
                "label": "Play Therapy"
              },
              {
                "taxonomyId": "12c18e6d-7a56-47f4-9076-a35cd0c5881c",
                "label": "Prolonged Exposure (PE)"
              },
              {
                "taxonomyId": "f7f43d0e-e676-4af0-bc08-08960f43154d",
                "label": "Recreational Therapy"
              },
              {
                "taxonomyId": "962542fa-6fc1-4c6c-8287-01e784ba9210",
                "label": "Seeking Safety"
              },
              {
                "taxonomyId": "8cf6cbe8-b441-4ded-a4ec-a8ccc181e980",
                "label": "Therapeutic Community"
              },
              {
                "taxonomyId": "4b26a1aa-3eae-4935-b7c3-212819576084",
                "label": "Transcranial Magnetic Stimulation (TMS)"
              },
              {
                "taxonomyId": "83c35059-9478-49de-b25d-5028addefc17",
                "label": "Trauma-Informed Care"
              },
              {
                "taxonomyId": "1deee738-ef88-4724-9e01-3e6bea5a57b7",
                "label": "Other"
              }
            ]
          },
          {
            "key": "other_modalities",
            "question": "Other Modalities Offered",
            "inputType": "long_text",
            "required": false,
            "helper": "Please be as specific as possible",
            "options": [],
            "revealedBy": {
              "questionKey": "modalities",
              "taxonomyId": "1deee738-ef88-4724-9e01-3e6bea5a57b7"
            }
          },
          {
            "key": "specialties",
            "question": "Treatment Specialties",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "a7df8067-2757-4285-9342-4e2f3d6b2900",
                "label": "Anxiety & Panic Disorders"
              },
              {
                "taxonomyId": "bcd32992-155e-4321-a7f2-ad69e8495f86",
                "label": "Autism Spectrum Disorder (ASD)"
              },
              {
                "taxonomyId": "47634ca1-e10f-4015-be35-f48acf9566e1",
                "label": "Co-occurring Disorders (Dual Diagnosis)"
              },
              {
                "taxonomyId": "80ac5f88-907c-4742-a682-8813208cdd56",
                "label": "Depression & Mood Disorders"
              },
              {
                "taxonomyId": "d8107245-b038-4e7e-84a1-a1f8b1d6b65d",
                "label": "Eating Disorders (Medically Complex)"
              },
              {
                "taxonomyId": "e15ebfe2-753d-4a95-b911-c7bb111d6681",
                "label": "Eating Disorders (Medically Stable)"
              },
              {
                "taxonomyId": "df739836-36a0-494f-a229-d8524dc1396c",
                "label": "Failure to Launch"
              },
              {
                "taxonomyId": "65aaa9aa-5ee0-4b29-995c-819f33551013",
                "label": "Gaming Addiction"
              },
              {
                "taxonomyId": "0d767761-1e51-40e9-a183-63dc62908330",
                "label": "Intellectual & Developmental Disabilities"
              },
              {
                "taxonomyId": "994f6457-2a3c-444f-80ff-f7992c0ee101",
                "label": "Mental Health Only (No SUD)"
              },
              {
                "taxonomyId": "ae406bf7-84eb-4f88-8187-0a20d9d90abb",
                "label": "Obsessive Compulsive Disorders"
              },
              {
                "taxonomyId": "c20ef8b3-00c7-412b-b47f-35bbf8410870",
                "label": "Pornography Addiction"
              },
              {
                "taxonomyId": "2d44912a-d0af-4b8c-9070-643b39b450d4",
                "label": "Psychotic Disorders"
              },
              {
                "taxonomyId": "a95ade6b-680d-4f0a-b6f7-1de0faed2549",
                "label": "Severe and Persistent Mental Illness (SPMI)"
              },
              {
                "taxonomyId": "92f6c72d-c4ca-47f3-bcd0-ddffb63b98e3",
                "label": "Sex Addiction"
              },
              {
                "taxonomyId": "80502f87-e8ec-4f79-9870-ab10220a65c8",
                "label": "Shopping/Compulsive Spending"
              },
              {
                "taxonomyId": "f8b95b84-3a49-409e-afae-79f93bf76d46",
                "label": "Substance Use Primary (SUD)"
              },
              {
                "taxonomyId": "fb3d281c-a995-49db-a77e-fe36b099fb6e",
                "label": "Suicidal Ideation & Stabilization"
              },
              {
                "taxonomyId": "33d3b3d5-6f3c-4952-bce0-362b597fb283",
                "label": "Technology Addiction"
              },
              {
                "taxonomyId": "bde2fddb-f007-46c5-8e95-bffd26412895",
                "label": "Trauma & PTSD"
              },
              {
                "taxonomyId": "72058c01-0df6-4888-9602-c8b0c510a236",
                "label": "Other"
              }
            ]
          },
          {
            "key": "other_specialties",
            "question": "Other Treatment Specialties",
            "inputType": "long_text",
            "required": false,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "specialties",
              "taxonomyId": "72058c01-0df6-4888-9602-c8b0c510a236"
            }
          },
          {
            "key": "populations",
            "question": "Populations Served",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "1eaf7812-309c-4457-9dad-cb4fc56a5d34",
                "label": "Adolescents"
              },
              {
                "taxonomyId": "4e779ea8-8174-4d75-a6a6-2a02d1da6206",
                "label": "Adults (18-65)"
              },
              {
                "taxonomyId": "7e89983b-c078-4324-a77b-bbde30bd2e7a",
                "label": "Children & Teens"
              },
              {
                "taxonomyId": "248e1d36-536b-4ffe-8612-b4734ccadf07",
                "label": "Court Ordered Clients"
              },
              {
                "taxonomyId": "9c29529e-eac5-43ee-9569-203ba839d199",
                "label": "First Responders"
              },
              {
                "taxonomyId": "c530351a-d438-425d-b2cf-30f776571c2a",
                "label": "Gender Specific"
              },
              {
                "taxonomyId": "3024c2e7-f2dc-4929-a604-2a24ee51b305",
                "label": "LGBTQIA+"
              },
              {
                "taxonomyId": "2054d240-13cf-4b28-9c07-1333abe30387",
                "label": "Men Only"
              },
              {
                "taxonomyId": "d5191ad0-3d81-42a6-9800-118249c12462",
                "label": "Non Binary"
              },
              {
                "taxonomyId": "0bf99534-4340-4cfc-bc12-a57b4c4e29bc",
                "label": "Older Adults (55-65)"
              },
              {
                "taxonomyId": "a13b293c-407b-4d87-9256-80166e090d76",
                "label": "Parenting Individuals"
              },
              {
                "taxonomyId": "adefef26-f241-4b62-aa3f-b39d24184483",
                "label": "Pregnant Individuals"
              },
              {
                "taxonomyId": "a4d7ca76-74b3-4217-95b5-e17831289128",
                "label": "Pregnant Women"
              },
              {
                "taxonomyId": "3789d732-0fb5-4463-a15a-995469c52b68",
                "label": "Professionals/Executives"
              },
              {
                "taxonomyId": "b91c8293-b3d4-494e-a218-3567d0584412",
                "label": "Seniors (65+)"
              },
              {
                "taxonomyId": "7c0100dd-4a77-4d1b-b333-bffc32aea803",
                "label": "Teens (11-17)"
              },
              {
                "taxonomyId": "ad25c4b8-f12e-4a51-b199-fbe8498add57",
                "label": "Transgender Female"
              },
              {
                "taxonomyId": "281cbe07-a6ab-497c-ab3d-c073685c727b",
                "label": "Transgender Male"
              },
              {
                "taxonomyId": "e4106876-fb1c-4dbb-b8c7-3f5eefd65967",
                "label": "Tribal/Native American Populations"
              },
              {
                "taxonomyId": "7142e438-0bef-46df-8cb9-317b2df5def7",
                "label": "Veterans"
              },
              {
                "taxonomyId": "ef90ca8a-51ce-4db0-9527-036a86d2f5c8",
                "label": "Women"
              },
              {
                "taxonomyId": "9f223a9e-02a8-4e00-a0b4-9f1344f52fa8",
                "label": "Women Only"
              },
              {
                "taxonomyId": "4ecf1203-152f-4867-b6b9-3c2b6c40cf8f",
                "label": "Young Adults (18-28)"
              },
              {
                "taxonomyId": "47452594-c3bd-4909-82e5-7fb8f1599765",
                "label": "Other"
              }
            ]
          },
          {
            "key": "other_populations",
            "question": "Other Populations Served",
            "inputType": "long_text",
            "required": false,
            "helper": "Please be as specific as possible",
            "options": [],
            "revealedBy": {
              "questionKey": "populations",
              "taxonomyId": "47452594-c3bd-4909-82e5-7fb8f1599765"
            }
          },
          {
            "key": "age_min",
            "question": "Minimum Age Served",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "age_max",
            "question": "Maximum Age Served",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          }
        ]
      },
      {
        "key": "diagnoses",
        "title": "Diagnoses (Treated & Exclusionary)",
        "helper": "Specify which diagnoses are treated and which are exclusionary for the program.",
        "questions": [
          {
            "key": "diagnoses_accepted",
            "question": "Diagnoses Accepted",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "2381db0f-f4f5-4cd5-812f-b44858c7695d",
                "label": "ADD/ADHD"
              },
              {
                "taxonomyId": "200ac08b-08f8-44e8-933b-bf4d6fb0e8c4",
                "label": "Anxiety & Panic Disorders"
              },
              {
                "taxonomyId": "52e9338c-fde6-4a74-9466-a625bf9f7f94",
                "label": "Autism Spectrum Disorder (Level 1)"
              },
              {
                "taxonomyId": "da39c965-9413-4dd3-8929-2db58a90c35f",
                "label": "Autism Spectrum Disorder (Level 2 & 3)"
              },
              {
                "taxonomyId": "32ac15e8-d75b-4a32-8ce3-e378f520dada",
                "label": "Bipolar 1 Disorder"
              },
              {
                "taxonomyId": "cb37aed7-6188-4237-a4b2-2ac26b7c0d17",
                "label": "Bipolar 2 Disorder"
              },
              {
                "taxonomyId": "58d49f0f-e8eb-472e-9bf4-6a95b41de935",
                "label": "Borderline Personality Disorder (BPD)"
              },
              {
                "taxonomyId": "ef994f87-c56e-4688-abeb-6ab2ef7d408a",
                "label": "Complex PTSD"
              },
              {
                "taxonomyId": "1d0d8f5f-98a4-4fd5-86ba-8187aad6abc8",
                "label": "Dissociative Disorders (DID)"
              },
              {
                "taxonomyId": "69f7a546-de2c-4fc8-89d0-227caf317e0c",
                "label": "Eating Disorders (Medically Complex)"
              },
              {
                "taxonomyId": "1ddc464d-0991-42e8-bf1b-8890a8187ebf",
                "label": "Eating Disorders (Medically Stable)"
              },
              {
                "taxonomyId": "c4c04970-2a94-4139-bc3e-fa68be9b8102",
                "label": "Gambling Disorder"
              },
              {
                "taxonomyId": "581d4af4-8d8c-4eb4-b67a-316f9d5987d0",
                "label": "Generalized Anxiety Disorder"
              },
              {
                "taxonomyId": "41b317ab-d298-4c13-9f03-5488e521fee7",
                "label": "Major Depressive Disorder"
              },
              {
                "taxonomyId": "5a23b3ba-998d-4124-b1e4-642e515b6cd1",
                "label": "Obsessive-Compulsive Disorder (OCD)"
              },
              {
                "taxonomyId": "214fee14-8299-41e6-bcee-dac59aa04f0e",
                "label": "Personality Disorders"
              },
              {
                "taxonomyId": "4718fa8d-5468-40ec-a79b-66cb9827a01d",
                "label": "Post-Traumatic Stress Disorder (PTSD)"
              },
              {
                "taxonomyId": "3debf016-7fd4-40e9-9773-efdf58eb8360",
                "label": "Schizoaffective Disorder"
              },
              {
                "taxonomyId": "46b7c83c-e71f-4cb6-9891-6efa9627373d",
                "label": "Schizophrenia"
              },
              {
                "taxonomyId": "53e2dc1a-77c2-4634-8c37-bdc29f7dba3f",
                "label": "Substance Use Disorders"
              },
              {
                "taxonomyId": "5b7906c9-40b7-42dc-bf84-3e2b44541b0d",
                "label": "Trauma & PTSD"
              },
              {
                "taxonomyId": "2544a962-b47d-4e79-8faa-f868c082c7b4",
                "label": "Other"
              }
            ]
          },
          {
            "key": "other_diagnoses_accepted",
            "question": "Other Diagnosis Accepted",
            "inputType": "long_text",
            "required": false,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "diagnoses_accepted",
              "taxonomyId": "2544a962-b47d-4e79-8faa-f868c082c7b4"
            }
          },
          {
            "key": "exclusionary_criteria",
            "question": "Exclusionary Criteria",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "d5ce8683-45f1-4d3d-8637-a919efdb8433",
                "label": "Active Eating Disorder"
              },
              {
                "taxonomyId": "7f5823a3-ae91-4999-99b5-457fc37e8c3d",
                "label": "Active Mania"
              },
              {
                "taxonomyId": "1857b01d-e6e2-4509-97b8-aea615329340",
                "label": "Active Psychosis"
              },
              {
                "taxonomyId": "ce426ef9-d897-43a7-86b8-243ef0d13b79",
                "label": "Active Seizure Disorder"
              },
              {
                "taxonomyId": "aa6d3b7c-88df-486b-b0b1-8e4e72b34ca7",
                "label": "Any Recent Violence"
              },
              {
                "taxonomyId": "52e9338c-fde6-4a74-9466-a625bf9f7f94",
                "label": "Autism Spectrum Disorder (Level 1)"
              },
              {
                "taxonomyId": "da39c965-9413-4dd3-8929-2db58a90c35f",
                "label": "Autism Spectrum Disorder (Level 2 & 3)"
              },
              {
                "taxonomyId": "83dddf29-d43a-4521-b3f0-cdf8e0a85a36",
                "label": "History of Self-Harm (Not Current)"
              },
              {
                "taxonomyId": "a0d7785f-6fc5-4581-828a-d42f2cf9934b",
                "label": "Homicidal ideation"
              },
              {
                "taxonomyId": "c49791cb-35df-4f5a-9033-bd1ebd410f60",
                "label": "Mental Health Only (No SUD)"
              },
              {
                "taxonomyId": "d913a4ce-8124-45b1-a605-96b969683f5b",
                "label": "Oxygen Dependent"
              },
              {
                "taxonomyId": "30ad63ea-5232-44b5-8a7e-80e0882e586f",
                "label": "Pregnancy"
              },
              {
                "taxonomyId": "0de60c90-acc3-4523-b457-f9ebc09dd1f9",
                "label": "Psychotic Disorders"
              },
              {
                "taxonomyId": "7c5f9a22-833f-487c-8163-9b73d5edcfec",
                "label": "Registered Sex Offender"
              },
              {
                "taxonomyId": "2d941a98-17d1-4369-9cea-702bc09f30ea",
                "label": "Requires 24/7 Nursing"
              },
              {
                "taxonomyId": "3a01ea14-e77d-4563-bfcd-09e22a6bdd07",
                "label": "Self-Harm (Current non life threatening)"
              },
              {
                "taxonomyId": "cc09c8ce-e576-4c13-83e7-308949da4cea",
                "label": "Suicide Attempt (Last 90 Days)"
              },
              {
                "taxonomyId": "bd68c0e0-f94f-490c-bc1b-6a0192df7a11",
                "label": "Suicide Attempt (Within The Last Year)"
              },
              {
                "taxonomyId": "c75bc3e3-2d58-4ccd-85b5-57bf78feb7a4",
                "label": "Suicide Attempt While in a Facility"
              },
              {
                "taxonomyId": "246e88f2-1b91-45df-b773-5bfa586a603a",
                "label": "Violence Towards Healthcare Staff"
              },
              {
                "taxonomyId": "de8f2e88-9558-4ebd-866c-cdaa03c1591d",
                "label": "Violent Criminal Charges"
              },
              {
                "taxonomyId": "c29899c7-ef6c-4f5b-8d97-107a6d0fbc71",
                "label": "Violent/Aggressive Behavior"
              },
              {
                "taxonomyId": "5db3aee7-bb26-4b70-975a-3b2a914a9f14",
                "label": "Other (Please Specify)"
              }
            ]
          },
          {
            "key": "other_exclusionary_criteria",
            "question": "Other Exclusionary Diagnosis",
            "inputType": "long_text",
            "required": false,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "exclusionary_criteria",
              "taxonomyId": "5db3aee7-bb26-4b70-975a-3b2a914a9f14"
            }
          },
          {
            "key": "general_medical",
            "question": "General Medical",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "1c269dc6-8994-4fc6-86d9-71785712b992",
                "label": "24/7 On-Site Nursing"
              },
              {
                "taxonomyId": "7ddcd3ed-7eb2-4101-9ea3-437d77a1ea56",
                "label": "Access to 24/7 Nursing"
              },
              {
                "taxonomyId": "c0f720ab-8464-495c-a8b0-fa85ff874ff8",
                "label": "CPAP/BiPAP Support"
              },
              {
                "taxonomyId": "c9ec7ed7-c32d-4721-b61d-144512ee82bc",
                "label": "Diabetes Management"
              },
              {
                "taxonomyId": "6ec22a4a-3f22-40f1-9f40-ff5b242b0143",
                "label": "IV Medication Management"
              },
              {
                "taxonomyId": "f4f54384-4166-44e7-91e6-0666ebf98ae0",
                "label": "Medication Management"
              },
              {
                "taxonomyId": "6ad70b97-da40-40f6-9133-f5ebb738b1ac",
                "label": "On Site Medical Provider"
              },
              {
                "taxonomyId": "216e6ca5-64f8-4b52-be40-d1ce7d39a8de",
                "label": "Oxygen Therapy"
              }
            ]
          }
        ]
      },
      {
        "key": "insurance",
        "title": "Insurance & Payment",
        "helper": "Insurance plans accepted and available payment options. Please enter self-pay daily rate for residential treatment as well as the length of stay.",
        "questions": [
          {
            "key": "insurance_in_network",
            "question": "Insurances Accepted In-Network",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000001",
                "label": "Aetna"
              },
              {
                "taxonomyId": "0d261381-1d51-4452-b1a0-d930ca69ba95",
                "label": "Beacon"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000004",
                "label": "Blue Cross Blue Shield"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000002",
                "label": "Cigna"
              },
              {
                "taxonomyId": "7ee4e09d-8926-4d12-be1a-d4e08e83c0a5",
                "label": "DMBA"
              },
              {
                "taxonomyId": "0d1fe02b-0997-4ef1-99e7-25fbfae18eff",
                "label": "EMI"
              },
              {
                "taxonomyId": "85a469c7-c199-4076-b1c8-1f8a34b7fd18",
                "label": "First Health"
              },
              {
                "taxonomyId": "e6dbfe77-9d11-4ca9-a64d-50a9e5caecf1",
                "label": "Free"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000005",
                "label": "Humana"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000011",
                "label": "Medicaid"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000012",
                "label": "Medicare"
              },
              {
                "taxonomyId": "5cdeee56-3d5f-4530-9433-09392f8903ad",
                "label": "Motiv Health"
              },
              {
                "taxonomyId": "fb938b4c-7e09-490d-bc91-e08f6d00b56f",
                "label": "PEHP"
              },
              {
                "taxonomyId": "cb224df3-31e7-4700-b192-fd4ba36f7de4",
                "label": "Private Pay and Out-of-Network Only"
              },
              {
                "taxonomyId": "1efdc57e-9385-4416-8ed6-698a51e83e2e",
                "label": "Select Health"
              },
              {
                "taxonomyId": "247103b8-a093-44f9-b1da-5e63b9ab1cb5",
                "label": "TriCare"
              },
              {
                "taxonomyId": "bdcec3f0-255c-4e0b-8594-463e48afd11a",
                "label": "TriWest"
              },
              {
                "taxonomyId": "8117fa8c-c0d2-49c4-ab8d-38e926113f30",
                "label": "UMR"
              },
              {
                "taxonomyId": "5aab0da0-eddf-4805-991d-737068044841",
                "label": "United Healthcare"
              },
              {
                "taxonomyId": "5e4d676f-0527-4b93-9724-ffbfbb687603",
                "label": "University of Utah Health Plans"
              },
              {
                "taxonomyId": "e563cfb1-e215-49d6-a37f-c4d5561be03d",
                "label": "Wise Provider Networks"
              },
              {
                "taxonomyId": "a18d3b21-e6da-4346-b82f-c64d28c6e664",
                "label": "Other"
              }
            ]
          },
          {
            "key": "medicaid_plans",
            "question": "Utah Medicaid",
            "inputType": "multi_select",
            "required": false,
            "helper": "Which Utah Medicaid plans this program takes, and at what level of care.",
            "options": [
              {
                "taxonomyId": "4e29dcd4-8639-4e2e-9e7c-bf08cd51e7b1",
                "label": "Don't Accept"
              },
              {
                "taxonomyId": "da7824c8-7e84-4196-97db-4581d44e1b0b",
                "label": "Only accept at lower levels of care"
              },
              {
                "taxonomyId": "9c7414e5-b053-4aa5-b81d-9a9457a7c661",
                "label": "TAM"
              },
              {
                "taxonomyId": "6fde7922-c2e2-478c-b32a-c935d5f25a4b",
                "label": "Utah Medicaid - Traditional/Fee-for-Service"
              },
              {
                "taxonomyId": "92badb4e-4522-41d2-be4c-8ec197f853fb",
                "label": "Select Health Community Care"
              },
              {
                "taxonomyId": "2eb3b98e-75f9-4219-b96a-ac2828f58213",
                "label": "Molina Healthcare of Utah"
              },
              {
                "taxonomyId": "3ce71095-1c95-4de2-95c9-2fcadead7054",
                "label": "Health Choice Utah"
              },
              {
                "taxonomyId": "cdba38c7-67db-4ce6-990e-b046c2b62c0b",
                "label": "Healthy U"
              },
              {
                "taxonomyId": "977eec02-e8bc-46ff-a843-a7350fd275d7",
                "label": "Utah Medicaid - Other/Unknown"
              }
            ],
            "revealedBy": {
              "questionKey": "insurance_in_network",
              "taxonomyId": "40000000-0000-4000-8000-000000000011"
            }
          },
          {
            "key": "insurance_out_of_network",
            "question": "Insurance Accepted Out-of-Network",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000001",
                "label": "Aetna"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000004",
                "label": "BCBS"
              },
              {
                "taxonomyId": "40000000-0000-4000-8000-000000000002",
                "label": "Cigna"
              },
              {
                "taxonomyId": "7ee4e09d-8926-4d12-be1a-d4e08e83c0a5",
                "label": "DMBA"
              },
              {
                "taxonomyId": "0d1fe02b-0997-4ef1-99e7-25fbfae18eff",
                "label": "EMI"
              },
              {
                "taxonomyId": "cb32b5c5-0ca0-4a36-8bd0-633b924d8a2e",
                "label": "GEHA"
              },
              {
                "taxonomyId": "fb938b4c-7e09-490d-bc91-e08f6d00b56f",
                "label": "PEHP"
              },
              {
                "taxonomyId": "1efdc57e-9385-4416-8ed6-698a51e83e2e",
                "label": "Select Health"
              },
              {
                "taxonomyId": "bdcec3f0-255c-4e0b-8594-463e48afd11a",
                "label": "TriWest"
              },
              {
                "taxonomyId": "247103b8-a093-44f9-b1da-5e63b9ab1cb5",
                "label": "Tricare"
              },
              {
                "taxonomyId": "8117fa8c-c0d2-49c4-ab8d-38e926113f30",
                "label": "UMR"
              },
              {
                "taxonomyId": "5aab0da0-eddf-4805-991d-737068044841",
                "label": "United Healthcare"
              }
            ]
          },
          {
            "key": "payment_options",
            "question": "Payment Options",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "e8a1f176-bf40-48fb-98ed-c7e75e207b20",
                "label": "Out-of-Network Insurance"
              },
              {
                "taxonomyId": "5901a15b-32c5-49a4-a9b5-b5283c344cea",
                "label": "Payment Plans"
              },
              {
                "taxonomyId": "c6424300-10ba-4e97-8939-116bc367bcce",
                "label": "Private Insurance"
              },
              {
                "taxonomyId": "fcb11990-4124-465b-a203-62eb1c4eb932",
                "label": "Scholarships"
              },
              {
                "taxonomyId": "7ed6adf8-589b-4cc3-b4e7-23e55ede31fd",
                "label": "Self-Pay"
              },
              {
                "taxonomyId": "4e2d5241-2e9d-4bc5-8955-2008931440a3",
                "label": "Sliding Scale"
              },
              {
                "taxonomyId": "1586f0e2-9dc7-405a-bf2f-de2725524445",
                "label": "Other"
              }
            ]
          },
          {
            "key": "self_pay_daily_rate",
            "question": "Self Pay Daily Rate",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          }
        ]
      },
      {
        "key": "operations",
        "title": "Operational Capacity & Admission",
        "helper": "Admission, operational hours, and capacity details.",
        "questions": [
          {
            "key": "capacity",
            "question": "Capacity",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "hours_of_operation",
            "question": "Hours of Operation",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "admission_days",
            "question": "What Days Do You Accept Residential Admissions?",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "9c1ea02c-8b42-43d4-801c-f7e8b5f4f091",
                "label": "Sunday"
              },
              {
                "taxonomyId": "815601e1-4249-49ef-9f48-d66fb7ec74a8",
                "label": "Monday"
              },
              {
                "taxonomyId": "c16935ad-d952-4ae5-abb2-555fc9259b89",
                "label": "Tuesday"
              },
              {
                "taxonomyId": "0f0d8fe3-796f-413e-8fde-21f2e8704599",
                "label": "Wednesday"
              },
              {
                "taxonomyId": "a4fdb9af-4a7c-4f96-abb5-d35a3ff409eb",
                "label": "Thursday"
              },
              {
                "taxonomyId": "277f7fea-b9fb-4076-82d3-c3022579fd3e",
                "label": "Friday"
              },
              {
                "taxonomyId": "648d5ee4-9bed-40d4-bfbe-9e2a5cf95ba2",
                "label": "Saturday"
              }
            ]
          },
          {
            "key": "intake_hours",
            "question": "Intake Hours",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "60fce3a3-0a2b-4a7d-b529-ef5fda734b16",
                "label": "24/7"
              },
              {
                "taxonomyId": "139ccb90-c7fb-40cb-9f24-eecd23745f27",
                "label": "Daytime Hours (8am-5pm)"
              },
              {
                "taxonomyId": "279ef467-d084-4ec6-8984-7414c43fbbe4",
                "label": "Extended hours (morning through evening)"
              },
              {
                "taxonomyId": "618a1a82-34a6-4f4d-a7fd-1f672319fcea",
                "label": "Other"
              }
            ]
          }
        ]
      },
      {
        "key": "access",
        "title": "Language & Accessibility",
        "helper": "Languages spoken by staff and accessibility features available.",
        "questions": [
          {
            "key": "languages",
            "question": "Languages Spoken",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "7262ec9e-41e9-43c0-9319-4772461c0854",
                "label": "ASL"
              },
              {
                "taxonomyId": "98d17c60-ce95-4249-b979-16a113dba8e1",
                "label": "English"
              },
              {
                "taxonomyId": "9bd44ac3-d74f-464a-b53d-d3633e0614b5",
                "label": "Haitian Creole"
              },
              {
                "taxonomyId": "29bbcbe8-6607-49a0-bc13-d0d7d0a917f9",
                "label": "Khmer"
              },
              {
                "taxonomyId": "5b4dfb97-ac67-48e3-a17e-d7413f828e39",
                "label": "Mandarin"
              },
              {
                "taxonomyId": "3fecf4bb-6836-49dc-98df-9a9cab75ea5c",
                "label": "Portuguese"
              },
              {
                "taxonomyId": "cf9f3249-512b-40f4-a530-64205273f08d",
                "label": "Russian"
              },
              {
                "taxonomyId": "fc7eebfa-a690-4d05-95af-28a958d5c72f",
                "label": "Spanish"
              },
              {
                "taxonomyId": "324c7511-05fc-405e-b5f7-6787e32549a9",
                "label": "Other"
              }
            ]
          },
          {
            "key": "accessibility",
            "question": "Accessibility Features",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "70ad16bf-4ef1-414b-a88c-042511e47cff",
                "label": "ASL Interpreter"
              },
              {
                "taxonomyId": "41754e39-8283-4189-bda1-d13f2dde4168",
                "label": "Childcare"
              },
              {
                "taxonomyId": "ac87da10-6034-4b00-ad0f-6208e956dc92",
                "label": "Emotional Support Animal"
              },
              {
                "taxonomyId": "b18b3c81-1708-439b-a426-ed0707ce0f72",
                "label": "Sensory Rooms"
              },
              {
                "taxonomyId": "d8796469-42d8-4f70-8a57-122bf73e9479",
                "label": "Service Animal"
              },
              {
                "taxonomyId": "10181bb5-42e0-49d2-8b1a-3613b6de849e",
                "label": "Telehealth Available"
              },
              {
                "taxonomyId": "a4806ac4-0ef6-4abc-aff5-103449eaa9c7",
                "label": "Transportation Assistance"
              },
              {
                "taxonomyId": "88bda0e2-85ef-491d-8885-3037ccd377cf",
                "label": "Wheelchair Accessible"
              },
              {
                "taxonomyId": "f590cbfd-5c57-4f3c-9e82-877dcb297e79",
                "label": "Other"
              }
            ]
          }
        ]
      },
      {
        "key": "additional",
        "title": "Additional Program Details",
        "helper": null,
        "questions": [
          {
            "key": "additional_details",
            "question": "Additional Program Details- Things that make you unique. Amenities, Services, Etc.",
            "inputType": "long_text",
            "required": false,
            "helper": null,
            "options": []
          }
        ]
      }
    ]
  },
  "sober_living": {
    "source": "sober_living",
    "title": "Matchpoint Provider Profile (Sober Living)",
    "estimate": "15-25 minutes",
    "sections": [
      {
        "key": "identity",
        "title": "Identity",
        "helper": null,
        "questions": [
          {
            "key": "program_name",
            "question": "Program Name",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "provider_type",
            "question": "Provider Type",
            "inputType": "single_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "5e16654c-4d04-41bd-8a4a-1aea8b31b9f8",
                "label": "MH Transitional Living"
              },
              {
                "taxonomyId": "06e1857d-ed26-425b-9301-24e5d163db72",
                "label": "SUD Sober Living"
              }
            ]
          }
        ]
      },
      {
        "key": "contact",
        "title": "Primary Contact Info",
        "helper": "Information for main program contact that would be receiving referrals.",
        "questions": [
          {
            "key": "contact_name",
            "question": "Primary Contact Full Name",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "contact_phone",
            "question": "Primary Contact Phone",
            "inputType": "phone",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "contact_email",
            "question": "Primary Contact Email",
            "inputType": "email",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "admissions_phone",
            "question": "Admissions Phone Number",
            "inputType": "phone",
            "required": true,
            "helper": null,
            "options": []
          }
        ]
      },
      {
        "key": "location",
        "title": "Location and Address",
        "helper": null,
        "questions": [
          {
            "key": "street_address",
            "question": "Street Address",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "city",
            "question": "City",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "state",
            "question": "State",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "postal_code",
            "question": "ZIP Code",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "county_region",
            "question": "County/Region",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "capacity",
            "question": "Capacity",
            "inputType": "short_text",
            "required": true,
            "helper": null,
            "options": []
          },
          {
            "key": "additional_locations",
            "question": "Additional Locations",
            "inputType": "location_list",
            "required": false,
            "helper": "Each other house this program runs. Each keeps its own bed count.",
            "options": []
          }
        ]
      },
      {
        "key": "program",
        "title": "Program Information",
        "helper": null,
        "questions": [
          {
            "key": "exclusionary_criteria",
            "question": "Exclusionary Criteria (program doesn't accept)",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "280e1965-edb8-4b92-b956-4532cbcc0de0",
                "label": "Active Suicidal Ideation"
              },
              {
                "taxonomyId": "52e9338c-fde6-4a74-9466-a625bf9f7f94",
                "label": "Autism Spectrum Disorder (ASD1 High Functioning)"
              },
              {
                "taxonomyId": "6dbe589d-bd91-4d3d-8d63-127b99c84875",
                "label": "Bipolar Disorder"
              },
              {
                "taxonomyId": "58d49f0f-e8eb-472e-9bf4-6a95b41de935",
                "label": "Borderline Personality Disorder (BPD)"
              },
              {
                "taxonomyId": "1d0d8f5f-98a4-4fd5-86ba-8187aad6abc8",
                "label": "Dissociative Identity Disorder (DID)"
              },
              {
                "taxonomyId": "31242786-d019-49fa-b981-d717a4b53338",
                "label": "Eating Disorders"
              },
              {
                "taxonomyId": "a0d7785f-6fc5-4581-828a-d42f2cf9934b",
                "label": "Homicidal ideation"
              },
              {
                "taxonomyId": "4ac19928-ea3f-4bc4-a16e-ad85c5ea0a4a",
                "label": "No Substance Use (Mental Health Only)"
              },
              {
                "taxonomyId": "5a23b3ba-998d-4124-b1e4-642e515b6cd1",
                "label": "OCD"
              },
              {
                "taxonomyId": "4718fa8d-5468-40ec-a79b-66cb9827a01d",
                "label": "PTSD"
              },
              {
                "taxonomyId": "1b59d6e2-16d9-4e09-9109-54323beac5ac",
                "label": "Passive Suicidal Ideation"
              },
              {
                "taxonomyId": "214fee14-8299-41e6-bcee-dac59aa04f0e",
                "label": "Personality Disorders"
              },
              {
                "taxonomyId": "3debf016-7fd4-40e9-9773-efdf58eb8360",
                "label": "Schizoaffective"
              },
              {
                "taxonomyId": "46b7c83c-e71f-4cb6-9891-6efa9627373d",
                "label": "Schizophrenia"
              },
              {
                "taxonomyId": "ebf3b8d1-7d5a-4270-92c5-57a940fa7174",
                "label": "Self-Harm"
              },
              {
                "taxonomyId": "cc09c8ce-e576-4c13-83e7-308949da4cea",
                "label": "Suicide Attempt (Last 90 Days)"
              },
              {
                "taxonomyId": "2c43450a-4a3b-4af5-9ec5-4b9e38144115",
                "label": "Trauma"
              },
              {
                "taxonomyId": "246e88f2-1b91-45df-b773-5bfa586a603a",
                "label": "Violence Towards Healthcare Staff"
              },
              {
                "taxonomyId": "5db3aee7-bb26-4b70-975a-3b2a914a9f14",
                "label": "Other"
              }
            ]
          },
          {
            "key": "other_exclusionary_criteria",
            "question": "Other Exclusionary Criteria",
            "inputType": "long_text",
            "required": false,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "exclusionary_criteria",
              "taxonomyId": "5db3aee7-bb26-4b70-975a-3b2a914a9f14"
            }
          },
          {
            "key": "populations",
            "question": "Populations Served",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "1eaf7812-309c-4457-9dad-cb4fc56a5d34",
                "label": "Adolescents"
              },
              {
                "taxonomyId": "4e779ea8-8174-4d75-a6a6-2a02d1da6206",
                "label": "Adults (18-65)"
              },
              {
                "taxonomyId": "bfd37354-cd0f-45f6-99a1-61fd460241eb",
                "label": "Children"
              },
              {
                "taxonomyId": "c530351a-d438-425d-b2cf-30f776571c2a",
                "label": "Gender Specific"
              },
              {
                "taxonomyId": "8c1c425a-29fc-42d0-a300-c52eed832238",
                "label": "LGBTQ+"
              },
              {
                "taxonomyId": "2054d240-13cf-4b28-9c07-1333abe30387",
                "label": "Men Only"
              },
              {
                "taxonomyId": "d5191ad0-3d81-42a6-9800-118249c12462",
                "label": "Non Binary"
              },
              {
                "taxonomyId": "0bf99534-4340-4cfc-bc12-a57b4c4e29bc",
                "label": "Older Adults (55-65)"
              },
              {
                "taxonomyId": "a4d7ca76-74b3-4217-95b5-e17831289128",
                "label": "Pregnant Women"
              },
              {
                "taxonomyId": "b91c8293-b3d4-494e-a218-3567d0584412",
                "label": "Seniors (65+)"
              },
              {
                "taxonomyId": "ad25c4b8-f12e-4a51-b199-fbe8498add57",
                "label": "Transgender Female"
              },
              {
                "taxonomyId": "281cbe07-a6ab-497c-ab3d-c073685c727b",
                "label": "Transgender Male"
              },
              {
                "taxonomyId": "7142e438-0bef-46df-8cb9-317b2df5def7",
                "label": "Veterans"
              },
              {
                "taxonomyId": "ef90ca8a-51ce-4db0-9527-036a86d2f5c8",
                "label": "Women"
              },
              {
                "taxonomyId": "9f223a9e-02a8-4e00-a0b4-9f1344f52fa8",
                "label": "Women Only"
              },
              {
                "taxonomyId": "4ecf1203-152f-4867-b6b9-3c2b6c40cf8f",
                "label": "Young Adults (18-28)"
              }
            ]
          },
          {
            "key": "age_min",
            "question": "Minimum Age Served",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "age_max",
            "question": "Maximum Age Served",
            "inputType": "short_text",
            "required": false,
            "helper": null,
            "options": []
          },
          {
            "key": "mat_policy",
            "question": "MAT Policy",
            "inputType": "multi_select",
            "required": false,
            "helper": "Allows:",
            "options": [
              {
                "taxonomyId": "04858b37-1c1b-4911-8778-e5b737ca206f",
                "label": "Antabuse"
              },
              {
                "taxonomyId": "a1483eea-7fe0-4b31-b7e1-1fe12175376a",
                "label": "Buprenorphine (Suboxone, Zubsolv, Sublocade, Brixadi)"
              },
              {
                "taxonomyId": "20a321a9-f7ab-4258-aaf7-f56581b0e37b",
                "label": "Methadone"
              },
              {
                "taxonomyId": "c2166a66-526a-48ea-a0d0-b2c36420549f",
                "label": "Naltrexone"
              },
              {
                "taxonomyId": "d57e597c-6e16-437c-945d-34e2e8bd4434",
                "label": "No MAT Offered"
              },
              {
                "taxonomyId": "2b2ef194-1403-4742-9ad2-6734bbd25d3a",
                "label": "Vivitrol"
              }
            ]
          },
          {
            "key": "methadone_max_dose_mg",
            "question": "Methadone Limit (in milligrams)",
            "inputType": "whole_number",
            "required": true,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "mat_policy",
              "taxonomyId": "20a321a9-f7ab-4258-aaf7-f56581b0e37b"
            }
          },
          {
            "key": "rules",
            "question": "Rules",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "a5e726e1-e1fe-4a0e-ae39-11a652a5b136",
                "label": "Approved Visitors Allowed"
              },
              {
                "taxonomyId": "10dbd3ed-033d-4e55-9998-c65c2160b9e8",
                "label": "Cell Phones Allowed"
              },
              {
                "taxonomyId": "ed4c0ea1-250a-4485-962c-a12f9bca4fc1",
                "label": "Nicotine-free"
              },
              {
                "taxonomyId": "2461dd5d-8c6f-4ffc-af77-cefc213550e3",
                "label": "Overnight Passes Allowed"
              },
              {
                "taxonomyId": "689dbdaa-dc91-4643-92b9-c28148648bb7",
                "label": "Smoking Allowed"
              },
              {
                "taxonomyId": "76a127b3-06e0-4d8a-88ac-651bc5985136",
                "label": "Vaping Allowed"
              },
              {
                "taxonomyId": "9043e760-c60c-4b81-9d27-37e03ceacd62",
                "label": "Vehicle Allowed"
              },
              {
                "taxonomyId": "d4c0bf93-5c7b-4401-be44-dd5abce16b9e",
                "label": "Other (Please Describe)"
              }
            ]
          },
          {
            "key": "other_rules",
            "question": "Other Rules",
            "inputType": "long_text",
            "required": false,
            "helper": null,
            "options": [],
            "revealedBy": {
              "questionKey": "rules",
              "taxonomyId": "d4c0bf93-5c7b-4401-be44-dd5abce16b9e"
            }
          },
          {
            "key": "acceptance_criteria",
            "question": "Acceptance Criteria",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "bf257abb-7cbe-48ef-b920-8f1dfb4fa811",
                "label": "12 step Meetings Required"
              },
              {
                "taxonomyId": "217a3809-b442-4b5f-b7b1-571b386ab23b",
                "label": "Curfew Required"
              },
              {
                "taxonomyId": "37c55dd0-e6b5-418b-914d-d631d393cddc",
                "label": "Higher Level of Care Step Down Required"
              },
              {
                "taxonomyId": "825f5691-7195-4f09-80a9-73b6689b372c",
                "label": "Interview Required"
              },
              {
                "taxonomyId": "47359015-32f5-48ab-a9ea-bef5960febf2",
                "label": "Must Complete Residential First"
              },
              {
                "taxonomyId": "f9f32c95-bf38-43ed-8adc-8ed5ea439a31",
                "label": "Must attend in-house Outpatient"
              },
              {
                "taxonomyId": "cb515e93-9bb2-476f-8a8b-521f910cdf5a",
                "label": "Outside Outpatient Allowed"
              },
              {
                "taxonomyId": "7d426d76-effb-46df-aa3c-47b035f96b86",
                "label": "Sponsor Required"
              },
              {
                "taxonomyId": "21ddf447-6e07-4d49-b3d4-b2e7deeb8cb3",
                "label": "Other (Please Describe)"
              }
            ]
          },
          {
            "key": "sobriety_requirement",
            "question": "Sobriety Time Requirement",
            "inputType": "multi_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "37997a7c-2201-4b22-975f-466751b6e95b",
                "label": "Provide Clean UA"
              },
              {
                "taxonomyId": "e770e00e-a72a-42b7-96f5-462e83472f87",
                "label": "1 week"
              },
              {
                "taxonomyId": "2e1ae4c6-b0b6-42ce-8db1-715db5478f86",
                "label": "2 weeks"
              },
              {
                "taxonomyId": "b8e09c4d-fe68-4771-aa94-dad1a77b59a3",
                "label": "3 weeks"
              },
              {
                "taxonomyId": "59f58e22-5d54-4335-ac36-c8a8a19c0ff7",
                "label": "30 Days"
              },
              {
                "taxonomyId": "88392cbe-85ac-49b7-bae8-71572eda6847",
                "label": "Case by Case"
              }
            ]
          },
          {
            "key": "resident_support",
            "question": "Resident Support",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "4f40ea8c-71d6-4064-8936-705b025c87c3",
                "label": "Case Management"
              },
              {
                "taxonomyId": "20435fd2-00c6-4357-b9c1-f837aafefcea",
                "label": "Employment Assistance"
              },
              {
                "taxonomyId": "c34240d3-012e-4c81-8720-d1f858843c5c",
                "label": "Family Support"
              },
              {
                "taxonomyId": "91a0e931-85a4-42aa-aab9-ab6ac169e1b9",
                "label": "Life Skills"
              },
              {
                "taxonomyId": "9423786e-ef79-42fc-a431-58ae25e42dad",
                "label": "Nutrition Education"
              },
              {
                "taxonomyId": "a1e06825-7f70-42ce-8b20-0461c11a13be",
                "label": "Recovery Coaching"
              },
              {
                "taxonomyId": "c54b7c97-04d5-432a-990c-9b8b203093e7",
                "label": "Recreational Activities"
              },
              {
                "taxonomyId": "21207c31-15e3-4090-951e-562eb51ce506",
                "label": "Transportation Assistance"
              },
              {
                "taxonomyId": "1ce98401-4831-4ad6-9516-8369925f83fd",
                "label": "Volunteer Opportunities"
              },
              {
                "taxonomyId": "235d272d-bc72-4bf6-820f-80044c44c10a",
                "label": "Other (Please Describe)"
              }
            ]
          },
          {
            "key": "resident_expectations",
            "question": "Resident Expectations",
            "inputType": "multi_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "4e61d9aa-4064-4322-b273-0097f0dcb32d",
                "label": "Chores Required"
              },
              {
                "taxonomyId": "3bb8580b-193d-49b4-9651-bafd25088b1b",
                "label": "Curfew"
              },
              {
                "taxonomyId": "3ad2e831-d0c4-4e56-a78e-5da8874cb4cf",
                "label": "Drug Testing"
              },
              {
                "taxonomyId": "49c62106-8fe3-4907-8626-105203cd0e5f",
                "label": "Employment Required"
              },
              {
                "taxonomyId": "d6c9e7eb-f0ad-423d-b8a0-be1996e65fff",
                "label": "Meeting Attendance Required (AA/NA/SMART)"
              },
              {
                "taxonomyId": "c8401e9c-4ca7-4080-9c0d-0a218b0d9a35",
                "label": "School Accepted"
              },
              {
                "taxonomyId": "e899fa37-5f00-4356-b353-d69027449d18",
                "label": "Volunteer Work Accepted"
              },
              {
                "taxonomyId": "9702a13b-2605-4f9d-bb91-33292b85565f",
                "label": "Weekly House Meeting"
              },
              {
                "taxonomyId": "bc2e61e6-22b6-4eea-9b84-5f6b36157aad",
                "label": "Other"
              }
            ]
          }
        ]
      },
      {
        "key": "cost",
        "title": "Cost",
        "helper": null,
        "questions": [
          {
            "key": "deposit",
            "question": "Deposit",
            "inputType": "single_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "0983b4ad-8674-45a4-81a1-cbca7549ff09",
                "label": "Yes"
              },
              {
                "taxonomyId": "e2228a0a-780c-4bcb-a9ec-3c077a4a6a17",
                "label": "No"
              },
              {
                "taxonomyId": "02b84533-1ada-47f7-9eac-126a6c7746ec",
                "label": "Case by Case"
              }
            ]
          },
          {
            "key": "deposit_amount",
            "question": "Deposit Amount",
            "inputType": "whole_number",
            "required": true,
            "helper": "In dollars.",
            "options": [],
            "revealedBy": {
              "questionKey": "deposit",
              "taxonomyId": "0983b4ad-8674-45a4-81a1-cbca7549ff09"
            }
          },
          {
            "key": "time_commitment",
            "question": "Up Front Time Commitment",
            "inputType": "single_select",
            "required": true,
            "helper": null,
            "options": [
              {
                "taxonomyId": "ab181c6d-eb7f-416a-929c-385a4c836503",
                "label": "1 Month"
              },
              {
                "taxonomyId": "1e24d7e3-070e-4913-bc9f-11ed50985ef6",
                "label": "2 Months"
              },
              {
                "taxonomyId": "140c6890-d701-447a-a2ee-6d247cc1fd2b",
                "label": "3 Months"
              },
              {
                "taxonomyId": "72f7d26d-5dc9-4893-ba5e-f312bba4944d",
                "label": "4 Months"
              },
              {
                "taxonomyId": "c75b55fa-e4e7-478c-83bd-a50776faa1c0",
                "label": "5 Months"
              },
              {
                "taxonomyId": "4723d464-973b-45f9-b0b4-f2e85ff8a001",
                "label": "6 Months"
              },
              {
                "taxonomyId": "395e327c-4282-470a-9adb-8cc68d9bd76f",
                "label": "7 Months"
              },
              {
                "taxonomyId": "58b3b4d0-a3f7-4b0b-932d-192159212b36",
                "label": "8 Months"
              },
              {
                "taxonomyId": "66574356-0506-473a-ab62-11e1430abcef",
                "label": "9 Months"
              },
              {
                "taxonomyId": "e754367c-134d-4f8c-8f76-22b6a763bbc4",
                "label": "10 Months"
              },
              {
                "taxonomyId": "5b1c61f5-1001-473e-acfd-9fc734ffd6c4",
                "label": "11 Months"
              },
              {
                "taxonomyId": "b883fecc-50a3-406a-aa58-95d2041e3eb9",
                "label": "1 Year"
              },
              {
                "taxonomyId": "95245f44-fcb2-4634-bb92-c83c9d07809c",
                "label": "Case by Case"
              }
            ]
          },
          {
            "key": "monthly_rent",
            "question": "Monthly Rent",
            "inputType": "whole_number",
            "required": true,
            "helper": "In dollars.",
            "options": []
          }
        ]
      },
      {
        "key": "staffing",
        "title": "Staffing",
        "helper": null,
        "questions": [
          {
            "key": "staffing",
            "question": "Staffing",
            "inputType": "single_select",
            "required": false,
            "helper": null,
            "options": [
              {
                "taxonomyId": "890185f1-027e-4309-933a-ee98388df3ff",
                "label": "Client house manger"
              },
              {
                "taxonomyId": "dcf9b126-9da5-436f-b4bb-bfa199629695",
                "label": "Daytime hours only"
              },
              {
                "taxonomyId": "89b0d6d5-6331-4cc8-9caf-80e8bdb82e12",
                "label": "Staff lives on site"
              }
            ]
          }
        ]
      },
      {
        "key": "additional",
        "title": "Additional Program Details",
        "helper": null,
        "questions": [
          {
            "key": "additional_details",
            "question": "Additional Program Details",
            "inputType": "long_text",
            "required": false,
            "helper": "Any other relevant information that would be useful to a referring professional.",
            "options": []
          }
        ]
      }
    ]
  }
} as const

/** The taxonomy kind of every option above, keyed by taxonomy id. */
export const GENERATED_OPTION_KINDS: Readonly<Record<string, TaxonomyKind>> = {
  "02352c58-949f-423d-b6a6-adea98c46360": "level_of_care",
  "02b84533-1ada-47f7-9eac-126a6c7746ec": "deposit_policy",
  "03ca8d3c-71a7-442a-8617-c895330a4111": "program_type",
  "04858b37-1c1b-4911-8778-e5b737ca206f": "mat_policy",
  "06e1857d-ed26-425b-9301-24e5d163db72": "program_type",
  "06e4a85c-cdc0-49fe-9fda-9ac3720c21ff": "admission_criterion",
  "06eb3ba2-0a06-4fc5-ad9e-b4ec7a347f05": "substance",
  "078c106b-49fe-4987-b74c-cd9d7c515791": "program_type",
  "07dd292f-feab-4bdd-b8db-fe481176d761": "medical_capability",
  "0983b4ad-8674-45a4-81a1-cbca7549ff09": "deposit_policy",
  "0bcea5ed-4449-4e0f-a0e7-11a9a3b009d2": "modality",
  "0be0a8a6-5350-46cd-bd11-6eb343dff15e": "condition",
  "0bf99534-4340-4cfc-bc12-a57b4c4e29bc": "population",
  "0c5208c1-3dd9-4576-8709-f4ccddb6c678": "modality",
  "0d1fe02b-0997-4ef1-99e7-25fbfae18eff": "insurance",
  "0d261381-1d51-4452-b1a0-d930ca69ba95": "insurance",
  "0d767761-1e51-40e9-a183-63dc62908330": "specialty",
  "0d768e15-668b-41c9-9fde-661411f43cc5": "condition",
  "0de60c90-acc3-4523-b457-f9ebc09dd1f9": "condition",
  "0dfde2e0-94b3-4d8b-941e-166161b5c3eb": "medical_capability",
  "0eef7208-0a92-4bb0-b4c1-3f97c21349e8": "modality",
  "0f0d8fe3-796f-413e-8fde-21f2e8704599": "admission_day",
  "10181bb5-42e0-49d2-8b1a-3613b6de849e": "accessibility",
  "10dbd3ed-033d-4e55-9998-c65c2160b9e8": "housing_rule",
  "12c18e6d-7a56-47f4-9076-a35cd0c5881c": "modality",
  "139ccb90-c7fb-40cb-9f24-eecd23745f27": "intake_hours",
  "140c6890-d701-447a-a2ee-6d247cc1fd2b": "time_commitment",
  "1531e60c-5025-44a3-b7e1-1bce7f53030b": "attendance",
  "1586f0e2-9dc7-405a-bf2f-de2725524445": "payment_option",
  "15ed97b3-ae3e-418e-bbc6-97422cc3e08e": "program_type",
  "16a2e235-a69b-4874-bf79-b12ff45e5d1f": "modality",
  "1759b382-3312-4b23-8178-3c3ed96e8385": "program_type",
  "180a1e8b-bf34-4972-bc11-fef740c21c6a": "program_type",
  "1857b01d-e6e2-4509-97b8-aea615329340": "condition",
  "18d1a05e-00e1-442c-9fcb-868dc0ffddbf": "modality",
  "19cca206-453b-45df-9ddf-81747913e3af": "modality",
  "1a3ecf9a-2cc7-48d7-a7c2-2c393670540d": "program_type",
  "1b59d6e2-16d9-4e09-9109-54323beac5ac": "admission_criterion",
  "1c269dc6-8994-4fc6-86d9-71785712b992": "medical_capability",
  "1c92597a-97ff-4cf5-9086-0c451381e2cf": "modality",
  "1ce98401-4831-4ad6-9516-8369925f83fd": "housing_support",
  "1d0d8f5f-98a4-4fd5-86ba-8187aad6abc8": "condition",
  "1ddc464d-0991-42e8-bf1b-8890a8187ebf": "condition",
  "1deee738-ef88-4724-9e01-3e6bea5a57b7": "modality",
  "1e24d7e3-070e-4913-bc9f-11ed50985ef6": "time_commitment",
  "1eaf7812-309c-4457-9dad-cb4fc56a5d34": "population",
  "1efdc57e-9385-4416-8ed6-698a51e83e2e": "insurance",
  "200ac08b-08f8-44e8-933b-bf4d6fb0e8c4": "condition",
  "20435fd2-00c6-4357-b9c1-f837aafefcea": "housing_support",
  "2054d240-13cf-4b28-9c07-1333abe30387": "population",
  "20789687-0357-463d-8545-7e3989ac2ccf": "modality",
  "20a321a9-f7ab-4258-aaf7-f56581b0e37b": "mat_policy",
  "21207c31-15e3-4090-951e-562eb51ce506": "housing_support",
  "214fee14-8299-41e6-bcee-dac59aa04f0e": "condition",
  "216e6ca5-64f8-4b52-be40-d1ce7d39a8de": "medical_capability",
  "217a3809-b442-4b5f-b7b1-571b386ab23b": "acceptance_criterion",
  "21ddf447-6e07-4d49-b3d4-b2e7deeb8cb3": "acceptance_criterion",
  "235d272d-bc72-4bf6-820f-80044c44c10a": "housing_support",
  "2381db0f-f4f5-4cd5-812f-b44858c7695d": "condition",
  "2461dd5d-8c6f-4ffc-af77-cefc213550e3": "housing_rule",
  "246e88f2-1b91-45df-b773-5bfa586a603a": "admission_criterion",
  "247103b8-a093-44f9-b1da-5e63b9ab1cb5": "insurance",
  "248e1d36-536b-4ffe-8612-b4734ccadf07": "population",
  "2544a962-b47d-4e79-8faa-f868c082c7b4": "condition",
  "277f7fea-b9fb-4076-82d3-c3022579fd3e": "admission_day",
  "279ef467-d084-4ec6-8984-7414c43fbbe4": "intake_hours",
  "280e1965-edb8-4b92-b956-4532cbcc0de0": "admission_criterion",
  "281cbe07-a6ab-497c-ab3d-c073685c727b": "population",
  "29bbcbe8-6607-49a0-bc13-d0d7d0a917f9": "language",
  "2b2ef194-1403-4742-9ad2-6734bbd25d3a": "mat_policy",
  "2c43450a-4a3b-4af5-9ec5-4b9e38144115": "condition",
  "2d44912a-d0af-4b8c-9070-643b39b450d4": "specialty",
  "2d941a98-17d1-4369-9cea-702bc09f30ea": "admission_criterion",
  "2e1ae4c6-b0b6-42ce-8db1-715db5478f86": "sobriety_requirement",
  "2eb3b98e-75f9-4219-b96a-ac2828f58213": "medicaid_plan",
  "2eb9f532-2d70-43ea-9ed3-10d74069415d": "condition",
  "3024c2e7-f2dc-4929-a604-2a24ee51b305": "population",
  "30ad63ea-5232-44b5-8a7e-80e0882e586f": "admission_criterion",
  "31242786-d019-49fa-b981-d717a4b53338": "condition",
  "324c7511-05fc-405e-b5f7-6787e32549a9": "language",
  "32ac15e8-d75b-4a32-8ce3-e378f520dada": "condition",
  "33d3b3d5-6f3c-4952-bce0-362b597fb283": "specialty",
  "3789d732-0fb5-4463-a15a-995469c52b68": "population",
  "37997a7c-2201-4b22-975f-466751b6e95b": "sobriety_requirement",
  "37c55dd0-e6b5-418b-914d-d631d393cddc": "acceptance_criterion",
  "38ca35d6-2393-4a6f-a54f-4327784563bf": "modality",
  "395e327c-4282-470a-9adb-8cc68d9bd76f": "time_commitment",
  "3a00b7a6-321c-4452-85ff-55871acd4f14": "substance",
  "3a01ea14-e77d-4563-bfcd-09e22a6bdd07": "admission_criterion",
  "3ad2e831-d0c4-4e56-a78e-5da8874cb4cf": "housing_expectation",
  "3bb8580b-193d-49b4-9651-bafd25088b1b": "housing_expectation",
  "3ce71095-1c95-4de2-95c9-2fcadead7054": "medicaid_plan",
  "3cf913d5-2737-411e-828a-290839d476e9": "medical_capability",
  "3debf016-7fd4-40e9-9773-efdf58eb8360": "condition",
  "3f5af506-59f8-4735-9dd4-d07bd777d8a0": "program_type",
  "3fecf4bb-6836-49dc-98df-9a9cab75ea5c": "language",
  "3ff67f53-0e7a-4244-91c9-8daae8f453bc": "admission_criterion",
  "40000000-0000-4000-8000-000000000001": "insurance",
  "40000000-0000-4000-8000-000000000002": "insurance",
  "40000000-0000-4000-8000-000000000004": "insurance",
  "40000000-0000-4000-8000-000000000005": "insurance",
  "40000000-0000-4000-8000-000000000011": "insurance",
  "40000000-0000-4000-8000-000000000012": "insurance",
  "40d9b900-de8d-4ee7-bbe4-9d966717d04d": "substance",
  "41754e39-8283-4189-bda1-d13f2dde4168": "accessibility",
  "41b317ab-d298-4c13-9f03-5488e521fee7": "condition",
  "46074796-5dbc-4905-b3ed-2570a91cb9e6": "level_of_care",
  "46b7c83c-e71f-4cb6-9891-6efa9627373d": "condition",
  "4718fa8d-5468-40ec-a79b-66cb9827a01d": "condition",
  "4723d464-973b-45f9-b0b4-f2e85ff8a001": "time_commitment",
  "47359015-32f5-48ab-a9ea-bef5960febf2": "acceptance_criterion",
  "47452594-c3bd-4909-82e5-7fb8f1599765": "population",
  "47634ca1-e10f-4015-be35-f48acf9566e1": "specialty",
  "49c62106-8fe3-4907-8626-105203cd0e5f": "housing_expectation",
  "4ac19928-ea3f-4bc4-a16e-ad85c5ea0a4a": "admission_criterion",
  "4b26a1aa-3eae-4935-b7c3-212819576084": "modality",
  "4cf731fd-d5e4-4ef2-a121-8987d767f012": "condition",
  "4e0f8e26-b7a8-4df2-bdae-d718b8e9163c": "medical_capability",
  "4e29dcd4-8639-4e2e-9e7c-bf08cd51e7b1": "medicaid_plan",
  "4e2d5241-2e9d-4bc5-8955-2008931440a3": "payment_option",
  "4e61d9aa-4064-4322-b273-0097f0dcb32d": "housing_expectation",
  "4e70dbd9-d594-42d1-9cf1-ee8c4f02318f": "program_type",
  "4e779ea8-8174-4d75-a6a6-2a02d1da6206": "population",
  "4ecf1203-152f-4867-b6b9-3c2b6c40cf8f": "population",
  "4f40ea8c-71d6-4064-8936-705b025c87c3": "housing_support",
  "4fb74ce6-74d5-4454-9b08-8705dcea433e": "condition",
  "4fdf5053-93de-4603-8ec2-4817273c0d38": "admission_criterion",
  "4ffc024e-9c69-4882-a2e5-f1549eb4e185": "medical_capability",
  "5090533c-adc3-4f7c-86cf-d6f9c24c64e9": "modality",
  "50c57747-b96d-44b9-8683-2d1071af74f1": "admission_criterion",
  "528b9342-80d2-4070-8f1c-b32260c2d319": "admission_criterion",
  "52e9338c-fde6-4a74-9466-a625bf9f7f94": "condition",
  "536b73aa-f579-4cd4-bae4-bf2985ddde5d": "admission_criterion",
  "53e2dc1a-77c2-4634-8c37-bdc29f7dba3f": "condition",
  "55e2778e-48fb-4683-8f9e-6f6f1f84cec0": "level_of_care",
  "57ea2975-bf27-49dc-9d9d-696f304a7872": "modality",
  "581d4af4-8d8c-4eb4-b67a-316f9d5987d0": "condition",
  "58b3b4d0-a3f7-4b0b-932d-192159212b36": "time_commitment",
  "58d49f0f-e8eb-472e-9bf4-6a95b41de935": "condition",
  "5901a15b-32c5-49a4-a9b5-b5283c344cea": "payment_option",
  "59792d6f-d6bd-401e-9877-de4644955dd0": "substance",
  "59e4f7e9-3ad3-4990-beda-b55e38b6ef74": "program_type",
  "59f58e22-5d54-4335-ac36-c8a8a19c0ff7": "sobriety_requirement",
  "5a23b3ba-998d-4124-b1e4-642e515b6cd1": "condition",
  "5aab0da0-eddf-4805-991d-737068044841": "insurance",
  "5b1c61f5-1001-473e-acfd-9fc734ffd6c4": "time_commitment",
  "5b4dfb97-ac67-48e3-a17e-d7413f828e39": "language",
  "5b7906c9-40b7-42dc-bf84-3e2b44541b0d": "condition",
  "5bed9da4-c70a-48a7-b146-73710aed3d54": "admission_criterion",
  "5cdeee56-3d5f-4530-9433-09392f8903ad": "insurance",
  "5db3aee7-bb26-4b70-975a-3b2a914a9f14": "admission_criterion",
  "5e16654c-4d04-41bd-8a4a-1aea8b31b9f8": "program_type",
  "5e4d676f-0527-4b93-9724-ffbfbb687603": "insurance",
  "60dc71d9-b505-4922-bbbc-6113d226db0c": "attendance",
  "60fce3a3-0a2b-4a7d-b529-ef5fda734b16": "intake_hours",
  "618a1a82-34a6-4f4d-a7fd-1f672319fcea": "intake_hours",
  "61dbf384-7821-48a0-8b67-54d32d07d8e7": "modality",
  "629c2196-88b0-4e5f-b9ed-d8ad77cf5a3f": "program_type",
  "648d5ee4-9bed-40d4-bfbe-9e2a5cf95ba2": "admission_day",
  "65aaa9aa-5ee0-4b29-995c-819f33551013": "specialty",
  "66574356-0506-473a-ab62-11e1430abcef": "time_commitment",
  "689dbdaa-dc91-4643-92b9-c28148648bb7": "housing_rule",
  "69f7a546-de2c-4fc8-89d0-227caf317e0c": "condition",
  "6a980d67-5e9c-4a75-9454-7772f872a0bd": "level_of_care",
  "6ad70b97-da40-40f6-9133-f5ebb738b1ac": "medical_capability",
  "6dbe589d-bd91-4d3d-8d63-127b99c84875": "condition",
  "6e517743-009a-4626-901d-08d6603587d1": "modality",
  "6ec22a4a-3f22-40f1-9f40-ff5b242b0143": "medical_capability",
  "6edf11fc-cc30-4fd4-a682-70c14ba866ca": "admission_criterion",
  "6fde7922-c2e2-478c-b32a-c935d5f25a4b": "medicaid_plan",
  "70ad16bf-4ef1-414b-a88c-042511e47cff": "accessibility",
  "7142e438-0bef-46df-8cb9-317b2df5def7": "population",
  "72058c01-0df6-4888-9602-c8b0c510a236": "specialty",
  "7262ec9e-41e9-43c0-9319-4772461c0854": "language",
  "72f7d26d-5dc9-4893-ba5e-f312bba4944d": "time_commitment",
  "759a1b43-6c14-4080-8aed-8c4b11ba0296": "modality",
  "76a127b3-06e0-4d8a-88ac-651bc5985136": "housing_rule",
  "7ba7cd24-2f34-46f6-ab81-ffa8a49e9324": "admission_criterion",
  "7c0100dd-4a77-4d1b-b333-bffc32aea803": "population",
  "7c5f9a22-833f-487c-8163-9b73d5edcfec": "admission_criterion",
  "7d426d76-effb-46df-aa3c-47b035f96b86": "acceptance_criterion",
  "7ddcd3ed-7eb2-4101-9ea3-437d77a1ea56": "medical_capability",
  "7e89983b-c078-4324-a77b-bbde30bd2e7a": "population",
  "7ed6adf8-589b-4cc3-b4e7-23e55ede31fd": "payment_option",
  "7ee4e09d-8926-4d12-be1a-d4e08e83c0a5": "insurance",
  "7f5823a3-ae91-4999-99b5-457fc37e8c3d": "condition",
  "80502f87-e8ec-4f79-9870-ab10220a65c8": "specialty",
  "80ac5f88-907c-4742-a682-8813208cdd56": "specialty",
  "8117fa8c-c0d2-49c4-ab8d-38e926113f30": "insurance",
  "815601e1-4249-49ef-9f48-d66fb7ec74a8": "admission_day",
  "82517bdc-7dfe-4b30-a826-3d671def8403": "medical_capability",
  "825f5691-7195-4f09-80a9-73b6689b372c": "acceptance_criterion",
  "82a6b779-4615-4bcd-9c51-56f20ab68402": "program_type",
  "83c35059-9478-49de-b25d-5028addefc17": "modality",
  "83dddf29-d43a-4521-b3f0-cdf8e0a85a36": "admission_criterion",
  "85a469c7-c199-4076-b1c8-1f8a34b7fd18": "insurance",
  "869d672f-abc5-4aa4-ae72-fe9423c70c91": "substance",
  "88392cbe-85ac-49b7-bae8-71572eda6847": "sobriety_requirement",
  "88bda0e2-85ef-491d-8885-3037ccd377cf": "accessibility",
  "890185f1-027e-4309-933a-ee98388df3ff": "staffing_model",
  "89b0d6d5-6331-4cc8-9caf-80e8bdb82e12": "staffing_model",
  "8c1c425a-29fc-42d0-a300-c52eed832238": "population",
  "8cf6cbe8-b441-4ded-a4ec-a8ccc181e980": "modality",
  "9043e760-c60c-4b81-9d27-37e03ceacd62": "housing_rule",
  "91a0e931-85a4-42aa-aab9-ab6ac169e1b9": "housing_support",
  "9229d24a-a3b3-4fec-972d-69f701547766": "level_of_care",
  "92badb4e-4522-41d2-be4c-8ec197f853fb": "medicaid_plan",
  "92f6c72d-c4ca-47f3-bcd0-ddffb63b98e3": "specialty",
  "932d4fde-6bcb-4abb-a6c1-a1b1a38ac645": "level_of_care",
  "9423786e-ef79-42fc-a431-58ae25e42dad": "housing_support",
  "94e949d4-3eb9-4aa0-b927-1bcde34b2910": "modality",
  "95245f44-fcb2-4634-bb92-c83c9d07809c": "time_commitment",
  "962542fa-6fc1-4c6c-8287-01e784ba9210": "modality",
  "9674b0e7-585b-4d06-8560-2730f9e9ccf3": "substance",
  "9682bd64-c831-458e-a95d-772672297546": "substance",
  "9702a13b-2605-4f9d-bb91-33292b85565f": "housing_expectation",
  "977eec02-e8bc-46ff-a843-a7350fd275d7": "medicaid_plan",
  "9874a12d-ebdd-4f72-965c-179f238a49aa": "modality",
  "98d17c60-ce95-4249-b979-16a113dba8e1": "language",
  "993a25c7-3cbe-416c-a264-f78a24418010": "modality",
  "994f6457-2a3c-444f-80ff-f7992c0ee101": "specialty",
  "9bd44ac3-d74f-464a-b53d-d3633e0614b5": "language",
  "9c1ea02c-8b42-43d4-801c-f7e8b5f4f091": "admission_day",
  "9c29529e-eac5-43ee-9569-203ba839d199": "population",
  "9c7414e5-b053-4aa5-b81d-9a9457a7c661": "medicaid_plan",
  "9cc248da-211c-4b5f-a5d5-8bc14af291b9": "program_type",
  "9d3ad229-30f2-471f-bfcc-9cff0e47c001": "modality",
  "9f223a9e-02a8-4e00-a0b4-9f1344f52fa8": "population",
  "a0d7785f-6fc5-4581-828a-d42f2cf9934b": "admission_criterion",
  "a13b293c-407b-4d87-9256-80166e090d76": "population",
  "a1483eea-7fe0-4b31-b7e1-1fe12175376a": "mat_policy",
  "a1705bb3-c90f-4233-a812-3af1923962ea": "substance",
  "a18d3b21-e6da-4346-b82f-c64d28c6e664": "insurance",
  "a1e06825-7f70-42ce-8b20-0461c11a13be": "housing_support",
  "a20e5c96-1118-4a3f-88ed-b960d9c09204": "modality",
  "a4806ac4-0ef6-4abc-aff5-103449eaa9c7": "accessibility",
  "a4d7ca76-74b3-4217-95b5-e17831289128": "population",
  "a4fdb9af-4a7c-4f96-abb5-d35a3ff409eb": "admission_day",
  "a5e726e1-e1fe-4a0e-ae39-11a652a5b136": "housing_rule",
  "a6b5f71b-1327-48c7-910a-75a10e035b5a": "insurance",
  "a7df8067-2757-4285-9342-4e2f3d6b2900": "specialty",
  "a7f67f22-bba5-464d-85ef-0882ec93673e": "modality",
  "a95ade6b-680d-4f0a-b6f7-1de0faed2549": "specialty",
  "a9f80a6d-ca73-468f-82a2-3f888620de1f": "condition",
  "aa6d3b7c-88df-486b-b0b1-8e4e72b34ca7": "admission_criterion",
  "aa706d06-e152-4fe5-a5e9-16960a17a63c": "modality",
  "ab181c6d-eb7f-416a-929c-385a4c836503": "time_commitment",
  "ac87da10-6034-4b00-ad0f-6208e956dc92": "accessibility",
  "acbfa08c-9119-4b31-89bc-a58de6ed1c0f": "modality",
  "ad25c4b8-f12e-4a51-b199-fbe8498add57": "population",
  "adefef26-f241-4b62-aa3f-b39d24184483": "population",
  "ae406bf7-84eb-4f88-8187-0a20d9d90abb": "specialty",
  "af474dc2-2cc9-4bee-9cea-cf99b70e46f4": "attendance",
  "b18b3c81-1708-439b-a426-ed0707ce0f72": "accessibility",
  "b1b8cee0-d2c1-4e68-9723-91acad9b114f": "program_type",
  "b2ddc795-94bf-4800-9ceb-0060d5cb70dc": "substance",
  "b883fecc-50a3-406a-aa58-95d2041e3eb9": "time_commitment",
  "b8d3a392-5a41-437c-935e-0fba66ea19cb": "medical_capability",
  "b8e09c4d-fe68-4771-aa94-dad1a77b59a3": "sobriety_requirement",
  "b91c8293-b3d4-494e-a218-3567d0584412": "population",
  "b9790b44-5a7b-4261-8d88-c3ed9b3f0b05": "program_type",
  "bac79862-434e-4c3d-bdcd-60050def06d6": "program_type",
  "bbb17b54-8598-41dc-8fda-6556754f06ee": "insurance",
  "bbfbbe72-af7a-4787-97fe-3298eebad62f": "medical_capability",
  "bc2e61e6-22b6-4eea-9b84-5f6b36157aad": "housing_expectation",
  "bc52947c-f82b-4878-983a-a7e0dfac87c0": "program_type",
  "bcd32992-155e-4321-a7f2-ad69e8495f86": "specialty",
  "bd68c0e0-f94f-490c-bc1b-6a0192df7a11": "admission_criterion",
  "bdcec3f0-255c-4e0b-8594-463e48afd11a": "insurance",
  "bddfd045-3189-4448-84eb-951ce3a01fa5": "population",
  "bde2fddb-f007-46c5-8e95-bffd26412895": "specialty",
  "bf257abb-7cbe-48ef-b920-8f1dfb4fa811": "acceptance_criterion",
  "bfd37354-cd0f-45f6-99a1-61fd460241eb": "population",
  "c0348c95-418b-4991-a020-0f7e1db256b6": "modality",
  "c0f720ab-8464-495c-a8b0-fa85ff874ff8": "medical_capability",
  "c16935ad-d952-4ae5-abb2-555fc9259b89": "admission_day",
  "c20ef8b3-00c7-412b-b47f-35bbf8410870": "specialty",
  "c2166a66-526a-48ea-a0d0-b2c36420549f": "mat_policy",
  "c23481aa-ae1c-47bd-a1ff-68b8bc2846cf": "level_of_care",
  "c29899c7-ef6c-4f5b-8d97-107a6d0fbc71": "admission_criterion",
  "c34240d3-012e-4c81-8720-d1f858843c5c": "housing_support",
  "c4203e48-0343-44cc-a13d-dba3cc9ae4e9": "modality",
  "c49791cb-35df-4f5a-9033-bd1ebd410f60": "admission_criterion",
  "c4c04970-2a94-4139-bc3e-fa68be9b8102": "condition",
  "c530351a-d438-425d-b2cf-30f776571c2a": "population",
  "c54b7c97-04d5-432a-990c-9b8b203093e7": "housing_support",
  "c6424300-10ba-4e97-8939-116bc367bcce": "payment_option",
  "c75b55fa-e4e7-478c-83bd-a50776faa1c0": "time_commitment",
  "c75bc3e3-2d58-4ccd-85b5-57bf78feb7a4": "admission_criterion",
  "c8401e9c-4ca7-4080-9c0d-0a218b0d9a35": "housing_expectation",
  "c9c9a910-b2f0-4792-af74-e49e6aee10ee": "modality",
  "c9ec7ed7-c32d-4721-b61d-144512ee82bc": "medical_capability",
  "cada2901-f8c7-42ed-888d-7bcdea5bc486": "program_type",
  "cb224df3-31e7-4700-b192-fd4ba36f7de4": "payment_option",
  "cb32b5c5-0ca0-4a36-8bd0-633b924d8a2e": "insurance",
  "cb37aed7-6188-4237-a4b2-2ac26b7c0d17": "condition",
  "cb515e93-9bb2-476f-8a8b-521f910cdf5a": "acceptance_criterion",
  "cc09c8ce-e576-4c13-83e7-308949da4cea": "admission_criterion",
  "cd08a7eb-5f4f-4e37-ba7f-b4d9b41b2701": "modality",
  "cdba38c7-67db-4ce6-990e-b046c2b62c0b": "medicaid_plan",
  "ce426ef9-d897-43a7-86b8-243ef0d13b79": "condition",
  "cf9f3249-512b-40f4-a530-64205273f08d": "language",
  "d13a0487-53cf-42fd-8df8-9f2e33ce07c9": "level_of_care",
  "d13d4208-f070-4812-893d-08502faf3fc6": "modality",
  "d13f3b6d-16bc-46f3-bcc1-7e91b5192795": "admission_criterion",
  "d263bba0-48f1-435e-8dfb-5a7c5befbf68": "medical_capability",
  "d4c0bf93-5c7b-4401-be44-dd5abce16b9e": "housing_rule",
  "d5191ad0-3d81-42a6-9800-118249c12462": "population",
  "d57e597c-6e16-437c-945d-34e2e8bd4434": "mat_policy",
  "d5ce8683-45f1-4d3d-8637-a919efdb8433": "condition",
  "d6c9e7eb-f0ad-423d-b8a0-be1996e65fff": "housing_expectation",
  "d8107245-b038-4e7e-84a1-a1f8b1d6b65d": "specialty",
  "d8796469-42d8-4f70-8a57-122bf73e9479": "accessibility",
  "d913a4ce-8124-45b1-a605-96b969683f5b": "admission_criterion",
  "d9d629d7-4da6-473c-a8af-abd4a750d2e8": "substance",
  "da39c965-9413-4dd3-8929-2db58a90c35f": "condition",
  "da7824c8-7e84-4196-97db-4581d44e1b0b": "medicaid_plan",
  "db014a67-990b-4c52-9b27-30a9d20fc2d1": "medical_capability",
  "dcf9b126-9da5-436f-b4bb-bfa199629695": "staffing_model",
  "dd32c1f3-fa2d-4f79-be08-940545f890c4": "condition",
  "de8f2e88-9558-4ebd-866c-cdaa03c1591d": "admission_criterion",
  "df739836-36a0-494f-a229-d8524dc1396c": "specialty",
  "e15ebfe2-753d-4a95-b911-c7bb111d6681": "specialty",
  "e2046bac-5ef8-47c0-adf7-befb155b2ae1": "condition",
  "e2228a0a-780c-4bcb-a9ec-3c077a4a6a17": "deposit_policy",
  "e4106876-fb1c-4dbb-b8c7-3f5eefd65967": "population",
  "e563cfb1-e215-49d6-a37f-c4d5561be03d": "insurance",
  "e65cd9c6-08dc-4655-88ab-369c98dd32a2": "modality",
  "e6dbfe77-9d11-4ca9-a64d-50a9e5caecf1": "payment_option",
  "e754367c-134d-4f8c-8f76-22b6a763bbc4": "time_commitment",
  "e770e00e-a72a-42b7-96f5-462e83472f87": "sobriety_requirement",
  "e899fa37-5f00-4356-b353-d69027449d18": "housing_expectation",
  "e8a1f176-bf40-48fb-98ed-c7e75e207b20": "payment_option",
  "ebf3b8d1-7d5a-4270-92c5-57a940fa7174": "admission_criterion",
  "ebfec50c-e8ea-4de0-8061-793592c52dd0": "substance",
  "ed4c0ea1-250a-4485-962c-a12f9bca4fc1": "housing_rule",
  "ed75ddf5-95a1-4094-abfb-a2718fe9fe9d": "program_type",
  "edb35157-1ec5-4726-baf0-abf6a5ff0272": "admission_criterion",
  "ee38a62e-cb8d-472c-be9a-9a3fdc409d55": "modality",
  "ef90ca8a-51ce-4db0-9527-036a86d2f5c8": "population",
  "ef994f87-c56e-4688-abeb-6ab2ef7d408a": "condition",
  "f2905b82-d3e1-4dc2-a357-ab5a73a7fcaa": "modality",
  "f4f54384-4166-44e7-91e6-0666ebf98ae0": "medical_capability",
  "f590cbfd-5c57-4f3c-9e82-877dcb297e79": "accessibility",
  "f7f43d0e-e676-4af0-bc08-08960f43154d": "modality",
  "f8b95b84-3a49-409e-afae-79f93bf76d46": "specialty",
  "f9f32c95-bf38-43ed-8adc-8ed5ea439a31": "acceptance_criterion",
  "fb3d281c-a995-49db-a77e-fe36b099fb6e": "specialty",
  "fb938b4c-7e09-490d-bc91-e08f6d00b56f": "insurance",
  "fbb92d9a-7d90-4963-ac65-8a74028ab5f1": "modality",
  "fc7eebfa-a690-4d05-95af-28a958d5c72f": "language",
  "fcb11990-4124-465b-a203-62eb1c4eb932": "payment_option",
  "ff8d3dcd-351e-4e4a-8ab7-8ae2d40947d3": "level_of_care"
} as const
